const messages = {
  callcenter: {
    pageTitle: 'Módulo telefônico',
    pageSubTitle:
      'Entre em contato com os clientes pelo discador e preencha a pesquisa. Novos contatos serão disponibilizados assim que forem finalizados. ',
    pageRuleText: 'Ordem da pesquisa com base na regra: ',
  },
  login: {
    form: {
      emailInput: 'Informe seu e-mail',
      passwordInput: 'Informe sua senha',
      submitButton: 'Entrar',
      forgotPasswordLabel: 'Esqueceu a senha?',
    },
    tooltips: {
      emailValidation: {
        title: 'Erro',
        description: 'Por favor, informe um email válido.',
      },
      passwordValidation: {
        title: 'Erro',
        description: 'Por favor, informe uma senha.',
      },
      loginValidation: {
        title: 'Dados inválidos',
        description: 'Verifique os seus dados de acesso e tente novamente.',
      },
      loginNotAllowed: {
        title: 'Acesso negado',
        description: 'Você não possui permissão de acesso.',
      },
      blockByIncorrectLogin: {
        title: 'Usuário bloqueado',
        description:
          'Seu usuário foi bloqueado por excesso de tentativa. Entre em contato com o time de Suporte.',
      },
      genericError: {
        title: 'Erro',
        description:
          'Não pudemos processar sua requisição. Por favor, tente novamente mais tarde.',
      },
    },
  },
  forgotPassword: {
    form: {
      description:
        'Enviaremos um código em seu e-mail para recuperação de senha.',
      emailInput: 'Informe o email cadastrado',
      submitButton: 'Enviar código',
    },
    tooltips: {
      emailValidation: {
        title: 'Erro',
        description: 'Por favor, informe um email válido.',
      },
    },
  },
  validateCode: {
    form: {
      description: 'Enviamos o código de validação em seu e-mail.',
      codeInput: 'Insira o código recebido',
      submitButton: 'Enviar código',
    },
    tooltips: {
      codeValidation: {
        title: 'Erro',
        description: 'Por favor, informe o código enviado para o seu e-mail.',
      },
    },
  },
  changePassword: {
    form: {
      description: 'Mudança de senha.',
      newPasswordInput: 'Nova senha',
      passwordConfirmationInput: 'Confirme sua nova nenha',
      submitButton: 'Trocar senha',
      strongPassMessage:
        'IndeCX está atualizando sua política de segurança de senhas e precisamos que você cadastre uma nova senha segura na plataforma',
    },
    tooltips: {
      emptyFieldValidation: {
        title: 'Erro',
        description: 'Por favor, informe e confirme sua senha.',
      },
      passwordValidation: {
        title: 'Erro',
        description: 'As senhas devem ser iguais.',
      },
      strongPasswordValidation: {
        title: 'Erro',
        description: 'Senhas devem seguir nova política de segurança',
      },
    },
    alerts: {
      success: {
        title: 'Senha alterada!',
        description: 'Você já pode fazer o login com sua nova senha.',
      },
      failure: {
        title: 'Oops!',
        description: 'Houve uma falha no processamento. Tente novamente.',
      },
    },
  },
  unsubscribe: {
    thankYou: 'Obrigado',
    unsubscribeMsg:
      'Seu e-mail foi desinscrito com sucesso da nossa plataforma!',
    successTitle: 'Seu e-mail foi removido com sucesso!',
    confirm:
      'Clicando no botão abaixo você será descadastrado e não receberá mais esse tipo de e-mail',
    successSubTitle: 'Por favor, informe o motivo do seu cancelameno.',
    successSentFeedback: 'Obrigado por compartilhar o seu motivo!',
    successResubscribe: 'Pronto! você já foi cadastrado nesta lista novamente.',
    reasons: {
      dontReceiveEmails: 'Não desejo mais receber esses emails',
      notInterested: 'O conteúdo não me interessa',
      dontAllowReceiving:
        'Não gosto de receber este tipo de e-mail sem ser consultado',
      accidentallyCanceled:
        'Cancelei a subscrição sem querer! Quero subscrever de novo a esta lista, por favor',
      other: 'Outros',
    },
  },
  researchPage: {
    title: 'Pesquisa de Satisfação',
    firstMsg: 'Sua opinião é muito importante para nós!',
    secondMsg: 'Agradecemos sua participação',
    defaultFeedbackMessage: 'Quer deixar algum comentário?',
    send: 'Enviar',
    name: 'Nome',
    email: 'Email',
    phone: 'Telefone',
    errorMsg: {
      title: 'Oops... Algo deu errado!',
      description: 'Por favor, tente novamente mais tarde.',
    },
    noQuestion: {
      title: 'Oops... A pergunta principal não foi respondida.',
      description: 'Por favor, insira uma nota.',
    },
    unavailable: {
      title:
        'Poxa, infelizmente este link não está mais disponível para pesquisa!',
      description:
        'Mas não se preocupe, em breve o nosso time de especialistas enviará uma nova pesquisa para melhorar a sua experiência com o nosso produto e ficaremos muito felizes em receber o seu feedback!',
    },
  },
  ssoError: {
    title: 'Poxa, suas credenciais estão incorretas!',
    description:
      'Sua conta pode não existir ou está bloqueada. Entre em contato com o gestor responsável pela sua conta IndeCX.',
  },
  previewPage: {
    title: 'Pesquisa de Satisfação',
    firstMsg: 'Sua opinião é muito importante para nós!',
    secondMsg: 'Agradecemos sua participação',
    back: 'Voltar',
    send: 'Enviar',
  },
  notFound: {
    title: 'Página não encontrada',
    message:
      'A Pagina que você está tentando acessar não está disponível ou talvez nunca tenha existido.',
    knowMore: 'Saiba mais ',
    clickHere: 'clicando aqui.',
    back: 'Voltar',
  },
  ssoPage: {
    auth: 'Autenticando',
    noAuth: 'Não conseguiu autenticar',
  },
  authentication: {
    accessCode: 'Código de Acesso',
    validate: 'Validar',
    noAccess: 'Não tenho acesso a este telefone',
  },
  menu: {
    allActionsLabel: 'todas as ações',
    titleMasterSettings: 'Configurações Master',
    titleSettings: 'Configurações',
    titleMyProfile: 'Meu Perfil',
    titleExportPdf: 'Exportar para PDF',
    settings: {
      accountData: {
        name: 'Dados da conta',
        company: 'Empresa',
        cnpj: 'CNPJ',
        plan: 'Plano',
        email: 'E-mail',
        apiKey: 'API Key',
        privacyPolicy: 'Política de Privacidade',
        clickHere: 'Clique aqui para acessar.',
        none: 'Nenhuma',
        mainMetric: 'Métrica principal',
        mainTime: 'Periodo principal',
        addEmail: 'Adicionar e-mail',
        addPolicyLink: 'Link para Política de Privacidade',
        registerEmail: ' Cadastrar Email',
        chooseLogo: 'Escolher logo',
        companyEmail: 'Email da empresa',
        choosePrivacyPolicy: 'Escolher Política de Privacidade',
        cancel: 'Cancelar',
        saveLogo: 'Salvar logo',
        savePrivacyPolicy: 'Salvar Política de Privacidade',
        myCompany: 'Minha empresa',
        consumptionDetails: 'Detalhes de consumo',
        categories: 'Categorias',
        consumptionDetailsShootingAnswer:
          'DETALHAMENTO DO CONSUMO DISPARO/RESPOSTAS',
        channelDetailing: 'Detalhamento por canal',
        actionDetailing: 'Detalhamento por ação',
        titleListCategories: 'LISTA DE CATEGORIAS',
        titleListCategoriesGroup: 'LISTA DE GRUPOS DE CATEGORIAS',
        placeholderNewGroupTag: 'Novo grupo de tags',
        listTags: 'LISTA DE TAGS',
        tagsGroup: 'GRUPO DE TAGS',
        newTag: 'Nova Tag',
        customStatus: 'LISTA DE STATUS CUSTOMIZADOS',
        customRules: 'LISTA DE REGRAS DE TRATATIVAS',
        customFilters: 'LISTA DE FILTROS PERSONALIZADOS',
        placeholderStatus: 'Novo status customizado',
        placeholderRules: 'Nova regra de operação',
        selectedTag: 'SELECIONE O GRUPO DE TAGS',
        titleListTagsGroup: 'LISTA DE GRUPOS DE TAGS',
        newCategory: 'Nova categoria',
        newCategoryGroup: 'Novo grupo de categoria',
        selectCategoryGroup: 'Selecione o Grupo de Categorias',
        categoryGroup: 'Grupo de categoria',
        branch: 'Filial',
        ih2: 'IH2',
        addSubCategory: 'Add subcategoria',
        templates: 'Templates',
        custom: 'Criação/Customização de template',
        descriptionCustom:
          'Nessa tela você consegue criar templates compartilhados com todos os usuários da plataforma para que sejam utilizados nas tratativas dos seus clientes.',
        subject: 'Assunto',
        sender: 'Remetente',
        descriptionTemplate:
          'Configure e salve seus templates para que seja possível utilizá-los novamente de forma rápida e prática.',
        myTemplates: 'Meus templates',
        descriptionMyTemplates:
          'Selecione um template abaixo para visualizar a formatação do e-mail e faça alterações caso necessário.',
        saveTemplates: 'Salvar templates',
        save: 'Salvar',
        updateTemplate: 'Atualizar template',
        deleteTemplate: 'Deletar template',
        labels: {
          collectionChannel: 'Canal de coleta',
          shoot: 'Disparo',
          reminder: 'Lembrete',
          resend: 'Reenvio',
          replica: 'Réplica',
          totalShoots: 'Total de disparos',
          answers: 'Respostas',
          action: 'Ação',
          sms: 'SMS',
          wpp: 'Whatsapp',
          active: 'Ativo',
          name: 'Nome',
          others: 'Outros',
          conversion: 'Taxa de Conversão',
        },
        messages: {
          registerEmail: {
            title: 'Email Cadastrado!',
            description:
              'O novo e-mail de remetente foi cadastrado para a empresa!',
          },
          cost: {
            title: 'Email da Empresa',
            description:
              'Ao utilizar seu e-mail como remetente, terá um custo adicional por mês, deseja realmente habilitar essa opção?',
          },
          updateMetric: {
            title: 'Alterar métrica principal',
            description:
              'Tem certeza que deseja alterar sua métrica principal para visualização dos dados?',
          },
          updateMetricSucess: {
            title: 'Métrica Alterada!',
            description: 'Sua métrica principla foi alterada com sucesso!',
          },

          updatePeriod: {
            title: 'Alterar periodo principal',
            description:
              'Tem certeza que deseja alterar o seu Periodo principal para visualização dos dados?',
          },
          updatePeriodSucess: {
            title: 'Periodo Alterado!',
            description: 'Seu periodo principal foi alterada com sucesso!',
          },
          buttons: {
            btnCancel: 'Cancelar',
            btnUpdate: 'Alterar',
          },
          error: {
            title: 'Oops... Algo deu errado!',
            description: 'Erro',
          },
          updateLogo: {
            title: 'Logo Alterado!',
            description:
              'A página será recarregada para visualizar as mudanças...',
          },
          saveBranchRuleSuccess: {
            title: 'Sucesso!',
            description:
              'A Regra para a filial {branchDataName} foi cadastrada.',
          },
          saveBranchRuleError: {
            title: 'Erro',
            description: 'Algo deu errado!',
          },
          invalidEmail: {
            title: 'Email inválido',
            description: 'Digite um email válido',
          },
          privacyPolicyUpdate: 'Sua Política de Privacidade foi alterada!',
          enableResurvey: {
            switchLabel: 'Habilitar repesquisa',
            alertSuccess: {
              title: 'Successo!',
              description:
                'A configuração de repesquisa foi alterada para a sua empresa.',
            },
          },
          duplicatedGroup: {
            title: 'Oops',
            description: 'Grupo de Categoria já existente',
          },
          createdGroup: {
            title: 'Sucesso',
            description: 'Grupo de Categoria criado com sucesso!',
          },
          updatedGroup: {
            title: 'Sucesso',
            description: 'Grupo de Categoria atualizado com sucesso!',
          },
          deletedGroup: {
            title: 'Sucesso',
            description: 'Grupo de Categoria removido com sucesso!',
          },
          duplicatedCategory: {
            title: 'Oops',
            description: 'Categoria já existente',
          },
          createdCategory: {
            title: 'Sucesso',
            description: 'Categoria criada com sucesso!',
          },
          updatedCategory: {
            title: 'Sucesso',
            description: 'Categoria atualizada com sucesso!',
          },
          deletedCategory: {
            title: 'Sucesso',
            description: 'Categoria removida com sucesso!',
          },
          updatedSubCategory: {
            title: 'Sucesso',
            description: 'Subcategoria atualizada com sucesso!',
          },
        },
        notification: {
          button: 'Notificação por e-mail',
          modalTitle: 'Notificação por e-mail',
          modalDescription:
            'Você será alertado mensalmente sempre que o percentual de consumo da sua conta atingir 90% ou mais.',
          inputEmail: 'Digite o e-mail que receberá a notificação',
          enableNotification: 'Habilitar',
        },
        category: {
          removeTitle: 'Deletar categoria',
          removeDescription:
            'Todas as respostas vinculadas a essa categoria serão afetadas. Deseja continuar?',
          cancelDescription: 'Cancelar',
          deleteDescription: 'Deletar',
          successTitle: 'Sucesso!',
          successDescription: 'A categoria foi deletada com sucesso!',
        },
        subCategory: {
          removeTitle: 'Deletar subcategoria',
          removeDescription:
            'Todas as respostas vinculadas a essa subcategoria serão afetadas. Deseja continuar?',
          cancelDescription: 'Cancelar',
          deleteDescription: 'Deletar',
          successTitle: 'Sucesso!',
          successDescription: 'A subcategoria foi deletada com sucesso!',
        },
      },
      users: {
        name: 'Usuários',
        email: 'Email',
        titleNewUser: 'NOVO USUÁRIO',
        titleUpdateUser: 'Editar Usuário',
        titlePermissions: 'Permissões para {userName}',
        titleBranches: 'Filiais',
        titleIh2: 'IH2',
        titleViewingProfile: 'Perfil de Visualização',
        titleActions: 'Ações',
        placeholderNameUser: 'Nome do usuário',
        placeholderEmailUser: 'Email do usuário',
        placeholderPhoneUser: 'Celular do usuário',
        placeholderPostUser: 'Cargo do usuário',
        placeholderPassUser: 'Senha do novo usuário',
        placeholderBranch: 'Digite a filial',
        placeholderHierarchy: 'Digite o nome da Hierarquia',
        placeholderSearch: 'Faça uma busca...',
        placeholderProfileName: 'Nome do Perfil',
        invalidFeedbackName: 'Por favor, informe o nome do usuário.',
        invalidFeedbackEmail: 'Por favor, informe um e-mail válido.',
        invalidFeedbackPhone: 'Por favor, informe o celular do usuário.',
        invalidFeedbackPost: 'Por favor, informe o cargo do usuário.',
        invalidFeedbackProfile: 'Por favor, informe o perfil do usuário.',
        invalidFeedbackPass: 'Por favor, informe a senha do usuário.',
        invalidFeedbackSamePass: 'As senhas devem ser iguais.',
        listActions: 'Lista de ações',
        clear: 'Limpar',
        buttonRegister: 'Cadastrar',
        buttonPermissons: 'Permissões',
        buttonSave: 'Salvar',
        buttonCancel: 'Cancelar',
        chooseOption: 'Escolha uma opção',
        securityPassword:
          'Por questão de segurança a sua senha de acesso não é exibida na plataforma, porém você pode editá-las a qualquer momento',
        expiredSecurityPassword:
          'Por questão de segurança a sua senha de acesso deve ser alterada',
        expiredSendEmail: 'Enviaremos um código para o e-mail:',
        selectAll: 'Selecionar tudo',
        labels: {
          nameUser: 'Nome',
          phone: 'Celular',
          post: 'Cargo',
          currentPassword: 'Senha Atual',
          confirmNewPassword: 'Confirmar a nova senha',
          updatePassword: 'Alterar Senha',
          permission: 'Permissão',
          profile: 'Perfil',
          viewingProfile: 'Perfil de Visualização',
          passwordUser: 'Senha do novo usuário',
          repeatPassword: 'Repita a senha',
          user: 'Usuário',
          company: 'Empresa',
          lastLogin: 'Último Acesso',
          options: 'Opções',
          email: 'Email',
          telephone: 'Telefone',
          responsible: 'Responsável por tratativa',
          selectAll: 'Selecionar Tudo',
          branch: 'Filial',
          date: 'Data',
          enable: 'Habilitar',
          controlId: 'ControlId',
          actions: 'Ações',
          groupAction: 'Grupo de Ações',
          creationDate: 'Data de Criação',
          channel: 'Canal',
          status: 'Status',
          menu: 'Menu',
          master: 'Master',
          admin: 'Admin',
          analyst: 'Analista',
          other: 'Outro',
          none: 'Nenhum',
          accessPassword: 'Senha de Acesso',
          changeExpiredPassword: 'Atualizar Senha de Acesso',
          twoFactorText:
            'Sua conta está protegida com duplo fator de autenticação. Por favor, entre com o código de verificação que foi enviado para o email:',
          menuModal: 'Menu {position}',
        },
        messages: {
          registerUser: {
            text: 'Usuário Cadastrado',
            description: 'O novo usuário foi cadastrado no sistema!',
          },
          deleteUser: {
            text: 'Excluir Usuário',
            description:
              'Tem certeza que deseja excluir {name} da sua lista de usuários?',
          },
          savedChanges: {
            text: 'Alterações Salvas!',
            description:
              'As alterações para o usuário {userName} foram salvas com sucesso!',
          },
          failedUpdate: {
            text: 'Oops! Algo deu errado...',
            description:
              'Verifique o número do celular e e-mail do usuário e tente novamente.',
          },
          updatePermissions: {
            text: 'Erro',
            description:
              'Houve algum erro ao atribuir as filiais/hierarquias para o usuário. Por favor, tente novamente.',
          },
          editOk: {
            text: 'Alterações Salvas!',
            description1: 'As alterações para o usuário',
            description2: 'foram salvas com sucesso!',
          },
          editError: {
            text: 'Oops! Algo deu errado...',
            description:
              'Verifique o número do celular e e-mail do usuário e tente novamente.',
          },
          editUser: {
            title: 'Usuario Editado',
            description: 'O perfil foi editado com sucesso!',
          },
          incorrectData: {
            title: 'Dados incorretos',
            description: 'Por favor, preencha os campos corretamente.',
          },
          updatePassword: 'Senha atualizada com sucesso!',
          performedAssignments: 'Atribuições Realizadas!',
          newBranchesAssigned:
            'As novas filiais/hierarquias foram atribuidas ao usuário.',
          error: 'Erro',
          eightCharacters: 'Deve conter no mínimo 8 caracteres',
          containNumbers: 'Deve conter números',
          containCapitalLetters: 'Deve conter letras maiúsculas',
          containSpecialCharacters: 'Deve conter caracteres especiais',
        },
      },
      alertsNewsletters: {
        name: 'Alertas/Boletins',
        yes: 'Sim',
        no: 'Não',
        editRule: 'Editar Regra',
        cancel: 'Cancelar',
        save: 'Salvar',
        alerts: 'Alertas',
        bulletin: 'Boletins',
        ruleBranch: 'Regra de Filial {branchDataName}',
        close: 'Fechar',
        titleNewRule: 'NOVA REGRA',
        titleGeneral: 'Geral',
        titleBranch: 'Filial',
        diary: 'DIÁRIO',
        monthly: 'MENSAL',
        weekly: 'SEMANAL',
        yearly: 'ANUAL',
        none: 'Nenhum',
        buttonRegister: 'Cadastrar',
        buttonClear: 'Limpar',
        placeholderRuleName: 'Digite o nome da regra',
        placeholderEmail: 'Digite o email',
        placeholderStaggering: 'Digite o email do escalonamento',
        placeholderSearch: 'Faça uma busca...',
        feedbackRuleName: 'Por favor, informe o nome da regra.',
        feedbackEmail: 'Por favor, informe o email.',
        feedbackEmailUser: 'Por favor, informe o e-mail do usuário.',
        emailAlert: 'Emails que receberão alertas (por nota)',
        emailsAlertNote: 'Emails que receberão alertas (por nota)',
        alertNote: 'Receberão alertas (por nota)',
        staggering: 'Escalonamento',
        savedRules: 'Regras Salvas',
        actions: 'Ações',
        yesLabel: 'Sim',
        noLabel: 'Não',
        table: {
          branch: 'Filial',
          hasAlert: 'Possui alerta?',
          updated: 'Data de atualização de regra',
          options: 'Opções',
        },
        labels: {
          ruleName: 'Nome da regra',
          email: 'Email',
          onlyReplyComment: 'Apenas respostas com comentário',
          levelOneEmail: 'Email Nível 1',
          levelTwoEmail: 'Email Nível 2',
          levelThreeEmail: 'Email Nível 3',
          days: 'Dias',
          branch: 'Filial',
          haveAlert: 'Possui alerta?',
          ruleUpdateDate: 'Data de atualização de regra',
          options: 'Opções',
          selectAllNotes: 'Selecionar todas as notas',
        },
        messages: {
          insertNameRule: {
            title: 'Oops!',
            description: 'Por favor, insira um nome para a regra!',
          },
          ruleForBranch: {
            title: 'Oops!',
            description:
              'Para exibir as regras por filiais é necessário criar uma regra principal, deseja fazer isso?',
          },
          successRegisterRule: {
            title: 'Regra Cadastrada',
            description: 'A nova regra foi cadastrada com successo!',
          },
          handleDelete: {
            title: 'Tem certeza?',
            description:
              'Deseja excluir a regra de alerta para o filial {branchName}',
          },
          deleteRuleBrachSuccess: {
            title: 'Sucesso!',
            description: 'A regra para a filial {branchName} foi deletada.',
          },
          updateRule: {
            title: 'Sucesso!',
            description: 'A regra foi editada com sucesso!',
          },
          deleteRuleQuestion: {
            title: 'Deletar Regra',
            description:
              'Tem certeza que deseja deletar essa regra da sua lista?',
            cancel: 'Cancelar',
            delete: 'Deletar',
            deletedOk: 'Regra deletada com sucesso!',
          },
          deleteBranchRule: {
            title: 'Tem Certeza?',
            description:
              'Deseja realmente excluir a regra de alerta para a filial',
            deletedOkTitle: 'Sucesso!',
            deletedOkMsg1: 'A regra para a filial',
            deletedOkMsg2: 'foi deletada.',
          },
          enterNameRule: {
            title: 'Oops!',
            description: 'Por favor, insira um nome para a regra.',
          },
          ruleRegistered: 'A regra {newRuleName} ja foi cadastrada.',
          pleaseInsertNameRule: 'Por favor, insira um nome para a regra.',
        },
      },
      hierarchies: {
        name: 'Hierarquias',
        titleNewBranch: 'NOVA FILIAL',
        titleUpdateBranch: 'Editar Filial',
        titleNewHierarchies: 'NOVA HIERARQUIA',
        clear: 'Limpar',
        placeholderNameBranch: 'Digite o nome da filial',
        placeholderEnterDescription: 'Digite a descrição',
        placeholderEnterGroup: 'Digite o grupo',
        placeholderEnterCode: 'Digite o código',
        placeholderCustomField: 'Campo Customizado',
        placeholderValue: 'Valor',
        placeholderSearch: 'Faça uma busca...',
        placeholderIh2: 'Ex.: Vendas, Pós-Vendas, etc.',
        buttonRegister: 'Cadastrar',
        buttonCancel: 'Cancelar',
        buttonRemove: 'Remover',
        buttonSave: 'Salvar',
        feedbackInformBranch: 'Por favor, informe a filial.',
        feedbackInformDescription: 'Por favor, informe a descrição.',
        feedbackInformGroup: 'Por favor, informe o grupo.',
        feedbackInformCode: 'Por favor, informe o código.',
        feedbackInformHierarchiesName:
          'Por favor, informe o nome da hierarquia.',
        branchRemoved: 'Filial Removida!',
        hierarchyRemoved: 'Hierarquia Removida!',
        labels: {
          nameBranch: '*Filial',
          branch: 'Filial',
          creationDate: 'Data de Criação',
          options: 'Opções',
          description: 'Descrição',
          group: 'Grupo',
          code: 'Código',
          customField: 'Campo Customizado',
          value: 'Valor',
          hierarchiesName: '*Nome da Hierarquia',
          corporationName: 'Nome',
        },
        messages: {
          succesAddBranch: {
            title: 'Filial Adicionada',
            description: 'Uma nova filial foi criada!',
          },
          removeBranch: {
            title: 'Remover Filial?',
            description: 'Deseja realmente remover a filial selecionada?',
          },
          changesSaved: {
            title: 'Alterações Salvas!',
            description: 'As alterações foram salvas com sucesso!',
          },
          succesAddHierarchy: {
            title: 'Hierarquia Cadastrada',
            description: 'Uma nova hierarquia foi cadastrada!',
          },
          removeHierarchy: {
            title: 'Remover Hierarquia?',
            description: 'Deseja realmente remover a hierarquia selecionada?',
          },
        },
      },
      accessProfile: {
        name: 'Perfil de acesso',
        profileList: 'LISTA DE PERFIS',
        buttonNewProfile: 'Novo perfil',
        myProfile: 'Meu perfil',
        newPassword: 'Digite a nova senha',
        email: 'Email',
        profile: 'Perfil',
        telephone: 'Telefone',
        updatePassword: 'Alterar Senha',
        registerNewProfile: 'Cadastrar Novo Perfil',
        nameProfile: 'Nome',
        buttonCancel: 'Cancelar',
        confirmNewPassword: 'Confirmar a nova senha',
        nameUser: 'Nome',
        registeredIn: 'Cadastrado em',
        lastLogin: 'Último Acesso',
        post: 'Cargo',
        buttonRemove: 'Remover',
        removed: 'Removido',
        removeProfile: 'Remover perfil',
        options: 'Opções',
        editProfile: 'Editar perfil',
        personalInformation: 'Informações Pessoais',
        status: 'Status',
        informName: 'Por favor, informe o nome',
        informEmail: ' Por favor, informe o email.',
        informTelephone: 'Por favor, informe o telefone.',
        informPost: 'Por favor, informe o cargo.',
        accessPassword: 'Senha de Acesso',
        securityPassword:
          'Por questão de segurança a sua senha de acesso não é exibida na plataforma, porém você pode editá-las a qualquer momento',
        currentPassword: 'Senha Atual',
        messages: {
          editUser: {
            title: 'Usuario Editado',
            description: 'O perfil foi editado com sucesso!',
          },
          updatePassword: 'Senha atualizada com sucesso!',
        },
      },
      integrations: {
        name: 'Integrações',
        titleZenvia: 'Zenvia',
        titleEnterPhone: 'Digite celular para teste',
        titleStatus: 'Status da integração',
        titleCollectResponse: 'Webhook - Coleta de resposta',
        titleCollectShoot: 'Webhook - Coleta de disparo',
        titleApiKey: 'Chave de integração Via API',
        integrationHabilit: 'Habilitar Integração',
        integrationTest: 'Testar Integração',
        required: 'Requerido: http:// ou https://',
        postUrl: 'HTTP Post URL',
        descriptionCollect:
          'Esse evento permite a configuração de um end-point para recebimento dos dados coletados em tempo real de cada cliente.',
        descriptionModelReturn: 'Veja o modelo de retorno das informações.',
        descriptionApi:
          'Você pode utilizar a chave "company-key" para utilizar as APIs de integrações do Indecx. Consulte a documentação para mais detalhes.',
        companyKey: 'Chave da empresa',
        status: 'Status',
        integration: 'Integração',
        description: 'Descrição',
        enabled: 'Habilitado',
        descriptionZeenvia:
          'Utilize os créditos de SMS da sua conta Zeenvia integrando com o Indecx de forma fácil e rápida.',
        descriptionApiKey:
          'Habilite a opção para gerar a chave de autenticação e habilitar a opção de integração de API.',
        event: 'Evento',
        collectionAnswers: 'Coleta de resposta',
        collectDescription:
          'Cadastre um end-point para recebimento em tempo das respostas coletadas pelo Indecx.',
        loopDescription:
          'Cadastre um end-point para recebimento em tempo das tratativas realizadas sempre que um status de um cliente for concluído.',
        phone: 'Telefone',
        cancel: 'Cancelar',
        save: 'Salvar',
        userNameZenvia: 'Username zenvia',
        aggregateId: 'Aggregate Id',
        placeholderEnterUserName: 'Digite o username da zenvia',
        placeholderEnterPass: 'Digite o password da zenvia',
        placeholderEnterAggregateId: 'Digite o Aggregate Id',
        placeholderEnterUserTest: 'Digite o username do zenvia para teste',
        placeholderEnterPasswordTest: 'Digite o password do zenvia para teste',
        placeholderAggregateIdTest: 'Digite o aggregate id para teste',
        placeholderEnterPhone: 'Digite o celular para receber o sms',
        feedbackInformUserName: 'Por favor, informe username.',
        feedbackInformPass: 'Por favor, informe password.',
        feedbackInformAggregateId: 'Por favor, informe Aggregate Id.',
        passwordLabel: 'Password zenvia',
        disabled: 'Desabilitado',
        lineOneDescription:
          'Você pode utilizar os créditos de sua conta Zenvia habilitando a integração de forma rápida.',
        lineTwoDescription:
          'Preencha os campos abaixo com os dados da sua conta Zenvia, habilite a opção e pronto.',
        lineThreeDescription:
          'Todos os SMSs enviados pela plataforma utilizarão o saldo de sua conta Zenvia.',
        messages: {
          settingsSaved: {
            title: 'Configuração Salva!',
            description:
              'A configuração de integração com Zenvia foi salva com sucesso!',
          },
          successSendSMS: {
            title: 'SMS enviado com sucesso!',
            description: 'Sucesso',
          },
          errorSettings: {
            title: 'Erro',
            description: 'Configuração incorreta!',
          },
        },
      },
    },
    masterSettings: {
      titleNewCompany: 'NOVA EMPRESA',
      titleEditCompany: 'Editar Empresa',
      titleNewUser: 'NOVO USUÁRIO',
      titleAllCompanies: 'Todas as Empresas',
      titleAllUsers: 'Todos os Usuários',
      titleReports: 'Relatórios',
      titleNewReport: 'NOVO RELATÓRIO',
      logo: 'Logo',
      master: 'Master',
      admin: 'Admin',
      analyst: 'Analista',
      adminAccess: 'Admin access',
      ops: 'Oops!',
      general: 'Geral',
      segments: {
        foodDrinks: 'Alimentos e Bebidas',
        artAntiques: 'Arte e Antiguidades',
        religiousArticles: 'Artigos Religiosos',
        subscriptionsMagazines: 'Assinaturas e Revistas',
        automobilesVehicles: 'Automóveis e Veículos',
        babiesCompany: 'Bebês e Cia',
        giftsPromotionalMaterials: 'Brindes / Materiais Promocionais',
        toysGames: 'Brinquedos e Games',
        houseDecoration: 'Casa e Decoração',
        collectibles: 'Colecionáveis',
        coletiveShopping: 'Compras Coletivas',
        constructionTools: 'Construção e Ferramentas',
        cosmeticsPerfumery: 'Cosméticos e Perfumaria',
        coursesEducation: 'Cursos e Educação',
        vinylsDiscs: 'Discos de Vinil',
        homeAppliances: 'Eletrodomésticos',
        electronics: 'Eletrônicos',
        radioBroadcasters: 'Emissoras de Rádio',
        televisionBroadcasters: 'Emissoras de Televisão',
        jobs: 'Empregos',
        telemarketingCompanies: 'Empresas de Telemarketing',
        sportsLeisure: 'Esporte e Lazer',
        flowersBasketsGifts: 'Flores, Cestas e Presentes',
        photography: 'Fotografia',
        churchesTemplesReligiousInstitutions:
          'Igrejas / Templos / Instituições Religiosas',
        industryCommerceBusiness: 'Indústria, Comércio e Negócios',
        promotionalInflatables: 'Infláveis Promocionais',
        computing: 'Informática',
        tickets: 'Ingressos',
        musicalInstruments: 'Instrumentos Musicais',
        jewelry: 'Joalheria',
        recreation: 'Lazer',
        books: 'Livros',
        fashionAccessories: 'Moda e Acessórios',
        digitalMusic: 'Música Digital',
        businessOpportunities: 'Negócios e Oportunidades',
        otherServices: 'Outros Serviços',
        stationeryOffice: 'Papelaria e Escritório',
        easter: 'Páscoa',
        petShop: 'Pet Shop',
        cheers: 'Saúde',
        advocacyService: 'Serviço Advocaticios',
        newspaperMagazineDistributionService:
          'Serviço de Distribuição de Jornais / Revistas',
        administrativeServices: 'Serviços Administrativos',
        artisticServices: 'Serviços Artísticos',
        airportServices: 'Serviços de Aeroportos',
        agencyServices: 'Serviços de Agências',
        rentalLeasingServices: 'Serviços de Aluguel / Locação',
        warehousingServices: 'Serviços de Armazenagem',
        advisoryServices: 'Serviços de Assessorias',
        technicalAssistanceServicesFacilities:
          'Serviços de Assistência Técnica / Instalações',
        associationServices: 'Serviços de Associações',
        bloodBankServices: 'Serviços de Bancos de Sangue',
        libraryServices: 'Serviços de Bibliotecas',
        notaryServices: 'Serviços de Cartórios',
        lotteryServices: 'Serviços de Casas Lotéricas',
        clothingServices: 'Serviços de Confecções',
        consortiumServices: 'Serviços de Consórcios',
        consultingServices: 'Serviços de Consultorias',
        cooperativeServices: 'Serviços de Cooperativas',
        dispatcherServices: 'Serviços de Despachante',
        engineeringServices: 'Serviços de Engenharia',
        parkingServices: 'Serviços de Estacionamentos',
        shipyardServices: 'Serviços de Estaleiros',
        exportImportServices: 'Serviços de Exportação / Importação',
        geologistServices: 'Serviços de Geólogos',
        jewelerServices: 'Serviços de Joalheiros',
        auctioneerServices: 'Serviços de Leiloeiros',
        cleaningServices: 'Serviços de Limpeza',
        convenienceStoreServices: 'Serviços de Loja de Conveniência',
        laborServices: 'Serviços de Mão de Obra',
        publicOrganServices: 'Serviços de Órgão Públicos',
        researchServices: 'Serviços de Pesquisas',
        portServices: 'Serviços de Portos',
        healthWellnessServices: 'Serviços de Saúde / Bem Estar',
        insuranceServices: 'Serviços de Seguradoras',
        securityServices: 'Serviços de Segurança',
        signalingServices: 'Serviços de Sinalização',
        unionFederationServices: 'Serviços de Sindicatos / Federações',
        translationServices: 'Serviços de Traduções',
        transportServices: 'Serviços de Transporte',
        publicUtilityServices: 'Serviços de Utilidade Pública',
        servicesAgricultureLivestockFishFarming:
          'Serviços em Agricultura / Pecuária / Piscicultura',
        foodServices: 'Serviços em Alimentação',
        servicesArt: 'Serviços em Arte',
        communicationServices: 'Serviços em Comunicação',
        constructionServices: 'Serviços em Construção',
        ecologyEnvironmentServices: 'Serviços em Ecologia / Meio Ambiente',
        servicesElectronicsMetalMechanics:
          'Serviços em Eletroeletrônica / Metal Mecânica',
        partyEventServices: 'Serviços em Festas / Eventos',
        computerServices: 'Serviços em Informática',
        internetServices: 'Serviços em Internet',
        jeweleryWatchesOpticalServices: 'Serviços em Jóias / Relógios / Óticas',
        technologyServices: 'Serviços em Tecnologia',
        telephonyServices: 'Serviços em Telefonia',
        vehicleServices: 'Serviços em Veículos',
        esotericMysticalServices: 'Serviços Esotéricos / Místicos',
        financialServices: 'Serviços Financeiros',
        funeralServices: 'Serviços Funerários',
        generalServices: 'Serviços Gerais',
        graphicEditorialServices: 'Serviços Gráficos / Editoriais',
        animalServices: 'Serviços para Animais',
        servicesDisabled: 'Serviços para Deficientes',
        officeServices: 'Serviços para Escritórios',
        clothingForServices: 'Serviços para Roupas',
        socialAAssistanceServices: 'Serviços Socias / Assistenciais',
        shoppingCenters: 'Shopping Centers',
        tobacconist: 'Tabacaria',
        bankFee: 'Tarifas Bancárias',
        telephoneCharges: 'Tarifas Telefônicas',
        telephony: 'Telefonia',
        tourism: 'Turismo',
      },
      specific: 'Específico',
      clear: 'Limpar',
      noUserRegistered: 'Nenhum usuário cadastrado para esse empresa.',
      removedReport: 'Relatório excluido',
      removedCompany: 'Empresa excluida',
      buttonRegister: 'Cadastrar',
      buttonSave: 'Salvar',
      buttonCancel: 'Cancelar',
      placeholderCorporationName: 'Razão Social',
      placeholderCompanyName: 'Nome da empresa',
      placeholderUserName: 'Nome do usuário',
      placeholderPhone: 'Celular do usuário',
      placeholderCnpj: 'CNPJ da empresa',
      placeholderCountry: 'País da empresa',
      placeholderReference: 'Indicador de Data de Referência',
      placeholderPassword: 'Senha do novo usuário',
      placeholderSequence: 'Digite o segmento...',
      placeholderLogo: 'Escolha o logo da empresa',
      placeholderDropFile: 'Solte o arquivo aqui...',
      placeholderEmail: 'Email do usuário',
      placeholderSearch: 'Faça uma busca...',
      placeholderPostUser: 'Cargo do usuário',
      placeholderReportsName: 'Nome do relatório',
      feedbackInformCorporationName:
        'Por favor, informe a razão social da empresa.',
      feedbackInformCompanyName: 'Por favor, informe o nome da empresa.',
      feedbackInformCnpj: 'Por favor, informe o CNPJ da empresa.',
      feedbackInformSequence: ' Por favor, informe o seguimento da empresa.',
      feedbackInformPass: 'Por favor, informe a senha do usuário.',
      feedbackInformReport: 'Por favor, informe o nome do relatório.',
      feedbackInformBalance:
        'Para o plano personalizado, é necessário informar os saldos.',
      feedbackInformNameUser: 'Por favor, informe o nome do usuário.',
      feedbackInformEmail: 'Por favor, informe o email do usuário.',
      feedbackInformPhone: 'Por favor, informe o celular do usuário.',
      feedbackInformPost: 'Por favor, informe o cargo do usuário.',
      feedbackSamePass: 'As senhas devem ser iguais.',
      channelOptions: {
        demo: 'Demo',
        basic: 'Básico',
        intermediate: 'Intermediário',
        advanced: 'Avançado',
        custom: 'Personalizado',
        dev: 'Dev',
      },
      labels: {
        companyName: 'Razão Social',
        fantasyName: 'Nome Fantasia',
        cnpj: 'CNPJ',
        country: 'Pais',
        referenceDate: 'Indicador de data de referência',
        sequence: 'Segmento',
        plan: 'Plano',
        companyLogo: 'Logo da Empresa',
        smsMonth: 'SMS/Mês',
        emailMonth: 'Email/Mês',
        email: 'Email',
        name: 'Nome',
        limit: 'Limite',
        quantityEmail: 'Qtd Email',
        quantitySms: 'Qtd SMS',
        options: 'Opções',
        company: 'Empresa',
        phone: 'Telefone',
        post: 'Cargo',
        profile: 'Perfil',
        passwordUser: 'Senha do novo usuário',
        repeatPassword: 'Repita a senha',
        user: 'Usuário',
        lastAcess: 'Último Acesso',
        application: 'Aplicação',
        client: 'Cliente',
        activate: 'Ativar',
        report: 'Relatório',
        actions: 'Ações',
        sentiment: 'Habilitar análise de sentimento',
        enableAttach: 'Permitir upload (anexo) tratativa',
        enableAudioResponse: 'Permitir gravar áudio em respostas',
        privacyPolicy: 'Habilitar Política de Privacidade via link',
        channelTotem: 'Habilitar totem',
        channelCallCenter: 'Habilitar Click-to-call (Call center)',
      },
      messages: {
        removeCompany: {
          title: 'Excluir Empresa',
          description: 'Tem certeza de excluir a empresa?',
        },
        addCompany: {
          title: 'Empresa Cadastrada',
          description: 'A nova empresa foi cadastrada no sistema!',
        },
        error: {
          title: 'Erro',
          description:
            'Houve um erro ao cadastrar o cliente. Verifique os campos e sua internet e tente novamente mais tarde.',
        },
        successAddUser: {
          title: 'Usuário Cadastrado',
          description: 'O novo usuário foi cadastrado no sistema!',
        },
        selectCompany: {
          title: 'Oops...',
          description: 'Selecione uma empresa para o usuário.',
        },
        userMaster: {
          title: 'Oops...',
          description:
            'Usuários do tipo Master devem ser da empresa IndeCX obrigatóriamente.',
        },
        removeUser: {
          title: 'Excluir Usuário',
          description:
            'Tem certeza que deseja excluir {nameUser} da sua lista de usuários?',
        },
        changeOrderList: {
          title: 'Sucesso!',
          description: 'Ordem de relatórios alterada!',
        },
        addReport: {
          title: 'Sucesso!',
          description: 'Relatório cadastrado.',
        },
        removeReport: {
          title: 'Excluir relatório',
          description: 'Tem certeza de excluir o relatório?',
        },
      },
    },
    filter: {
      filters: 'Filtros',
      filterAactionGroup: 'Filtro por grupo de ações',
      filterAction: 'Filtro por ação',
      provincialMetric: 'Métrica Principal',
      NPS1a5: 'NPS de 1 a 5',
      NPS010: 'NPS de 0 a 10',
      CES1a5: 'CES de 1 a 5',
      CSAT1to5: 'CSAT de 1 a 5 (Top 2 box)',
      CSAT1to5Average: 'CSAT de 1 a 5 (Média)',
      CSAT0to10Average: 'CSAT de 0 a 10 (Média)',
      review5Stars: '5-Stars',
      likeDislike: 'Like/Dislike - 0 e 1',
      metricsUnavailable: 'Métricas indisponíveis',
      titleResetFilter: 'Restaurar filtro de indicador',
      titleResetFilterData: 'Restaurar filtro de dados do indicador',
      conclude: 'Aplicar e fechar',
      clearFilter: 'Limpar Filtros',
      loading: 'Carregando...',
      indicators: 'Dados do indicador - {indicatorData}',
      indicatorData: 'Dados do indicador',
      filterIh1: 'Filtro por - {ih1} ',
      filterIh2: 'Filtro por - {ih2} ',
      boxIndicator: 'Indicador - {indicatorName}',
      indicator: 'Indicador',
    },
    sidebar: {
      dashboard: 'Dashboard',
      actions: 'Ações',
      actionList: 'Lista de Ações',
      newAction: 'Nova Ação',
      actionGroup: 'Grupo de Ações',
      answers: 'Respostas',
      answersList: 'Lista Respostas',
      sentiment: 'Análise Sentimento',
      manualAnswer: 'Resposta Manual',
      categorization: 'Categorização',
      categorizationAdditional: 'Categorização Adicional',
      invites: 'Disparos',
      resend: 'Reenvio',
      reminders: 'Lembretes',
      scheduling: 'Agendamentos',
      treatments: 'Tratativas',
      individual: 'Individual',
      bulk: 'Em massa',
      reports: 'Relatórios',
      reportsList: 'Lista de Relatórios',
      clients: 'Clientes',
      clientsList: 'Lista Clientes',
      files: 'Arquivos',
      downloads: 'Downloads',
      uploads: 'Uploads',
      reccycleBin: 'Lixeira',
      version: 'Versão',
      quarentine: 'Quarentena',
      resendwpp: 'Whatsapp',
      treatmentsReview: 'Revisão',
      aiAnalysis: 'Análise IA',
    },
    navbar: {
      nps15: 'NPS 1 a 5',
      nps010: 'NPS 0 a 10',
      ces15: 'CES 1 a 5',
    },
    profile: 'Perfil',
    leave: 'Sair',
  },
  dashboard: {
    action: 'Ação',
    period: 'Período',
    brasil: 'Brasil',
    portugues: 'Português',
    ingles: 'English',
    colombia: 'Colombia',
    espanhol: 'Español',
    eua: 'Estados Unidos',
    all: 'Todos',
    invites: 'Convites',
    customers: 'Clientes',
    answers: 'Respostas',
    responsesRate: 'Tx. Respostas',
    totalResponseRate: 'Tx. Respostas Total',
    digitalResponseDate: 'Tx. Respostas Digital',
    groupActions: 'Grupo de ações',
    metric: 'Métrica',
    stockComparison: 'Comparativo de ações',
    updateList: 'Atualizar lista',
    todayFilter: 'Hoje',
    yesterdayFilter: 'Ontem',
    last30DaysFilter: 'Últimos 30 dias',
    currentMonthFilter: 'Mês atual',
    lastMonthFilter: 'Mês anterior',
    currentYearFilter: 'Ano atual',
    lastYearFilter: 'Ano anterior',
    everyPeriodFilter: 'Todo período',
    custom: 'Personalizado',
    CCSI: 'CCSI',
    HGSI: 'HGSI',
    PREHGSI: 'PRE-HGSI',
    FCSI: 'FCSI',
    labelsStockComparison: {
      actionName: 'Nome da ação',
      answers: 'Respostas',
      promoters: '% Promotores',
      neutral: '% Neutros',
      detractors: '% Detratores',
      nps: 'NPS',
      ces: 'CES',
      conversionRate: 'Taxa de conversão',
      invites: 'Convites',
    },
  },
  actionList: {
    pageTitle: 'Lista de ações',
    newActionButton: 'Nova ação',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    registerGroupAction: 'Cadastre um grupo',
    veryUnsatisfied: 'Muito insatisfeito',
    here: 'Aqui.',
    loading: 'Carregando...',
    updateList: 'Atualizar Lista',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    ces15: 'CES 1 a 5',
    csat15: 'CSAT 1 a 5 (Top 2 box)',
    csat15Average: 'CSAT 1 a 5 (Média)',
    csat0to10Average: 'CSAT 0 a 10 (Média)',
    likeDislike: 'Like/Dislike - 0 e 1',
    fiveStars: '5-Stars',
    both: 'ambos',
    details: 'Detalhes',
    edit: 'Editar',
    send: 'Enviar',
    clone: 'Clonar Ação',
    remove: 'Remover',
    executed: 'Executado em',
    scheduled: 'Agendado para',
    registerEmail: 'Cadastrar Email (remetente)',
    registerWebhook: 'Cadastrar webhook resposta',
    required: 'Requerido: http:// ou https://',
    saveWebhook: 'Salvar',
    testIntegration: 'Testar integração',
    habilitIntegration: 'Habilitar integração',
    messages: {
      remove: {
        title: 'Removendo uma Ação',
        description: `Tem certeza que deseja remover essa ação?
                     Isso pode afetar diretamente o calculo do seu NPS.`,
        okLabel: 'Remover',
        cancelLabel: 'Cancelar',
      },
      removeOk: {
        title: 'Ação removida!',
        description:
          'Seu NPS está sendo recalculado, isso poderá demorar alguns minutos.',
      },
      clone: {
        title: 'Clonando uma Ação',
        description:
          'Você está prestes a duplicar as configurações desta ação, deseja continuar?',
        okLabel: 'Duplicar',
        cancelLabel: 'Cancelar',
      },
      cloneOk: {
        title: 'Ação duplicada!',
        description: 'Todas as configurações da ação foram duplicadas.',
      },
    },
    actionTable: {
      labels: {
        id: 'ID',
        action: 'Ação',
        group: 'Grupo de ações',
        categoryGroup: 'Grupo de categoria',
        type: 'Tipo',
        date: 'Data de criação',
        channel: 'Canal',
        registers: 'Registros',
        quarentine: 'Quarentena',
        valids: 'Válidos',
        failures: 'Falhas',
        answers: 'Respostas',
        status: 'Status',
        options: 'Opções',
      },
      noClassifiedLabel: 'Sem classificação',
      status: {
        criado: 'criado',
        processando: 'processando',
        enviando: 'enviando',
        enviado: 'enviado',
        agendado: 'agendado',
        falha: 'falha',
        bloqueado: 'bloqueado',
        importando: 'importando',
        importado: 'importado',
      },
    },
    actionDetails: {
      details: 'Detalhes da ação',
      cleanInput: 'Limpar',
      placeholderSearch: 'Faça uma busca...',
      actionFilterStatus: {
        select: 'Filtro por status',
        all: 'Todos',
        processando: 'Processando',
        enviando: 'Enviando',
        enviado: 'Enviado',
        respondido: 'Respondido',
        quarentena: 'Quarentena',
        duplicado: 'Duplicado',
        bloqueado: 'Bloqueado',
        falha: 'Falha',
        importando: 'Importando',
        importado: 'Importado',
      },
      labels: {
        id: 'ID',
        name: 'Nome',
        email: 'E-mail',
        phone: 'Telefone',
        date: 'Data de Envio',
        days: 'Dias',
        channel: 'Canal',
        emailStatus: 'Val. Email',
        phoneStatus: 'Val. Telefone ',
        status: 'Status',
      },
      titleExportCSV: 'Exportar para CSV',
      titleExportXLS: 'Exportar para XLS',
      alertsActionDetails: {
        succes: {
          title: 'Sucesso!',
          description:
            'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
        },
      },
      notAnswered: 'Não respondido',
      answered: 'Respondido',
      valid: 'valido',
      invalid: 'invalido',
    },
    resurveyModal: {
      title: 'Configurar regra de repesquisa',
      cancelButton: 'Cancelar',
      saveButton: 'Salvar notas',
      description:
        'Selecione abaixo quais ações do tipo "Pesquisa" você quer aplicar o processo de repesquisa...',
      gradesDescription:
        'Para qual nota você gostaria de enviar a repesquisa para o cliente?',
      tableLabels: {
        name: 'Ação',
        actionGroup: 'Grupo de ações',
        createdAt: 'Data de criação',
        channel: 'Canal',
        resurvey: 'Habilitar repesquisa',
      },
    },
  },
  newAction: {
    modalTitle: 'Nova ação',
    createAction: 'Criar ação',
    stepsLabels: {
      selectMetric: 'Métrica principal',
      stepOne: 'Criar ação',
      stepTwo: 'Configuração',
      stepThree: 'Importar dados',
    },
    templateHTML: `<p>Obrigado por escolher a nossa empresa. <br> </p>
                  <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
                  questionário que dura apenas 60 segundos.
                  <br>
                  </p>
                  <p>Agradecemos a sua colaboração.<br></p>`,
    closeHTML: '<p>Obrigado por responder nossa pesquisa!</p>',
    dynamicClosingMessage: 'Encerramento dinâmico',
    dynamicClosingMessageText: {
      part1:
        'Você pode customizar a mensagem de encerramento de acordo com a nota atribuída pelo cliente.',
      part2:
        'Selecione as escalas de notas abaixo e customize o layout da página',
    },
    closingMessageGrades: {
      zeroToTen: {
        promoters: 'Notas 10 e 9',
        passives: 'Notas 8 e 7',
        detractors: 'Notas 6 a 0',
      },
      oneToFive: {
        promoters: 'Notas 5 e 4',
        passives: 'Nota 3',
        detractors: 'Notas 2 e 1',
      },
      zeroAndOne: {
        promoters: 'Nota 1',
        passives: '',
        detractors: 'Notas 0',
      },
    },
    autoReplyGrades: {
      zeroToTen: {
        promoters: 'Notas 10 e 9',
        passives: 'Notas 8 e 7',
        detractors: 'Notas 6 a 0',
      },
      oneToFive: {
        promoters: 'Notas 5 e 4',
        passives: 'Nota 3',
        detractors: 'Notas 2 e 1',
      },
      zeroAndOne: {
        promoters: 'Nota 1',
        passives: '',
        detractors: 'Notas 0',
      },
    },
    autoReplyText: {
      emailSubject: 'Assunto',
      emailSubjectPlaceholder: 'Informe o assunto do e-mail',
      emailSender: 'Remetente',
      emailSenderPlaceholder: 'Informe o nome do remetente',
    },
    buttonReturn: 'Voltar',
    buttonSave: 'Salvar Ação',
    buttonSaveConfig: 'Salvar Configurações',
    buttonSaveAndExit: 'Salvar e fechar',
    nameAction: 'NOME DA AÇÃO',
    answerSurvey: 'Responda a nossa pesquisa aqui:',
    anonymousAnswer: 'Quero responder de forma anônima',
    selectMetric: {
      pageTitle: 'Escolha sua métrica principal',
      button: {
        selectLabel: 'Selecionar',
        soonLabel: 'Em breve',
      },
      nps: {
        title: 'Quer saber o que é NPS?',
        description:
          'NPS, sigla de Net Promoter System ou Net Promoter Score, é um indicador de fidelidade e satisfação de clientes muito utilizado mundialmente. Ele mede, através de apenas uma pergunta, qual o nível de fidelidade e satisfação dos clientes com a empresa, serviço ou produto.',
      },
      ces: {
        title: 'Quer saber o que é CES?',
        description:
          'O Customer Effort Score(CES) ou Índice de Esforço do cliente(IEC) é um indicador de desempenho chave (KPI) para mensurar quanto esforço um cliente precisa gastar para obter uma resposta ou solução para um problema. Basicamente, ele é utilizado para criar uma experiência sem esforço para os clientes.',
      },
      csat: {
        title: 'Quer saber o que é CSAT?',
        description:
          'O Customer Satisfaction Score (CSAT) é uma métrica que demonstra o grau de satisfação do cliente com uma empresa, um produto ou um serviço. O CSAT é uma metodologia muito popular principalmente pela forma descomplicada de medir as respostas coletadas.',
      },
      reviews: {
        title: 'Quer saber o que é Reviews?',
        description:
          "5 Star Rating talvez seja a métrica mais comum e presente no nosso dia a dia, utilizada por muitas empresas nos setores de transporte por aplicativo, delivery's, bancos etc... Ela permite uma avaliação de forma mais visual (estrelas) e o resultado é calculado através de média ponderada.",
      },
      likert: {
        title: 'Quer saber o que é Likert?',
        description: `Escala Likert, métrica projetada para medir as atitudes, opiniões ou percepções das pessoas. Os clientes escolhem entre uma variedade de respostas possíveis o que mais reflete sua opinião como "Muito Satisfeito", "Satisfeito", "Indiferente", "Insatisfeito" e "Muito insatisfeito".`,
      },
      likeDislike: {
        title: 'Quer saber o que é o like/dislike?',
        description:
          'Conhecida como Thumbs Up/Down ou popular Like/Dislike é uma ótima opção para analisar feedback da forma mais direta possível, uma vez que é uma métrica muito comum utilizada em diversos aplicativos que usamos no dia a dia para avaliação.',
      },
    },
    stepOne: {
      labels: {
        actionName: 'Nome da ação',
        scale: 'Escala',
        methodology: 'Metodologia',
        collectionCanal: 'Canal de coleta',
        actionType: 'Tipo da ação',
        surveyType: 'Pesquisa',
        resurveyType: 'Repesquisa',
        question: 'Pergunta',
        infoQuestion:
          'Para alteração da pergunta principal, clique na opção editar do template principal (ícone lapis)',
        replicas: 'Réplicas',
        commentOrder: 'Ordem do comentário',
        afterAdditionalQuestion: 'Após a pergunta adicional',
        beforeAdditionalQuestion: 'Antes a pergunta adicional',
        additionalQuestion: 'Pergunta adicional',
        addQuestion: 'Pergunta adicional?',
        smsQuestion: 'Pergunta no SMS',
        cesScale: 'CES - escala de 1 a 5',
        csatScale: 'CSAT - escala de 1 a 5 (Top 2 box)',
        csatScaleAverage: 'CSAT - escala de 1 a 5 (Média)',
        csatScaleAverage0to10: 'CSAT - escala de 0 a 10 (Média)',
        fiveStars: 'Review - 5 Stars',
        likeDislike: 'Like/Dislike - 0 e 1',
        able: 'Habilitado',
        chooseOption: 'Escolha uma opção',
        settingSMS: 'Configuração do SMS',
        openFieldPromoters9a10: 'Campo aberto para promotores (notas 9 e 10)',
        openFieldPassives7e8: 'Campo aberto para neutros (notas 7 e 8)',
        openFieldDetractors0a6: 'Campo aberto para detratores (notas 0 a 6)',
        openFieldPromoters4e5: 'Campo aberto para promotores (notas 4 e 5)',
        openFieldPassives3: 'Campo aberto para neutros (nota 3)',
        openFieldDetractors1e2: 'Campo aberto para detratores (notas 1 a 2)',
        openFieldCESPromoters4e5: 'Campo aberto para notas 4 e 5',
        openFieldCESPassives3: 'Campo aberto para nota 3',
        openFieldCESDetractors1e2: 'Campo aberto para notas 1 a 2',
        sms: 'Digite a mensagem para o link da pesquisa:',
        openFieldCSAT4and5: 'Campo aberto para notas 4 e 5',
        openFieldCSAT3: 'Campo aberto para nota 3',
        openFieldCSAT1and2: 'Campo aberto para notas 1 e 2',
        openField5Stars4and5: 'Campo aberto para promotores (notas 4 e 5)',
        openField5Stars3: 'Campo aberto para neutros (nota 3)',
        openField5Stars1and2: 'Campo aberto para detratores (notas 1 e 2)',
        openFieldLikeDislike1: 'Campo aberto para promotores (nota 1)',
        openFieldLikeDislike0: 'Campo aberto para detratores (nota 0)',
        english: 'Inglês',
        spanish: 'Espanhol',
        portuguese: 'Português',
        modalTranslationAddQuestion:
          'Ao configurar a tradução das perguntas adicionais, os respondentes poderão escolher o idioma preferido para responder a pesquisa.',
        modalTranslationReplies:
          'Ao configurar a tradução das réplicas, os respondentes poderão escolher o idioma preferido para responder a pesquisa.',
      },
      saveChanges: 'Salvar alterações',
      radioOptions: {
        email: 'E-mail',
        sms: 'SMS',
        emailSMS: 'Email/SMS',
      },
      infoComment:
        'Ao habilitar essa opção, um campo de comentário ficará disponível para que o cliente adicione uma nota específica sobre essa pergunta adicional.',
      searchLink: 'Pesquisa com link no SMS',
      searchBody: 'Pesquisa no corpo do SMS',
      veryUnsatisfied: 'Muito insatisfeito',
      points0a10: '0 a 10 pontos',
      yes: 'SIM',
      email: 'E-mail',
      sms: 'SMS',
      emailSMS: 'E-mail/SMS',
      doNotExclude: 'NÃO EXCLUIR',
      detractorsSMS: 'Detratores',
      promotersSMS: 'Promoteres',
      placeholderDetractor: 'Digite a réplica para os detratores',
      placeholderNeutral: 'Digite a réplica para os neutros',
      placeholderPromoter: 'Digite a réplica para os promotores',
      placeholderEnterSubjectSMS: 'Digite o assunto do sms',
      placeholderTextLink: 'Texto para o link',
      placeholderTextBody: 'Texto no corpo da Mensagem',
      altCellPhone: 'celular',
      selectTitle: 'Selecionar {selectTemplate}',
      neutralSMS: 'Neutros',
      actionName: 'Informe o nome da ação',
      actionCesName: 'Nova ação CES',
      actionCSATName: 'Nova ação CSAT',
      action5StarsName: 'Nova ação 5-Stars',
      actionNameSize: 'Não pode exceder mais de 35 caracteres.',
      actionInvalid: 'Por favor, informe o nome da ação.',
      actionSavedAlert: 'Ação Salva!',
      skipSettings: 'Avançar Para Configurações',
      promoters: 'O que te motivou a dar essa nota?',
      neutral: 'Na sua opinião, o que falta para ganharmos nota máxima?',
      detractors: 'Na sua opinião, quais os itens devem ser melhorados?',
      surveyLayout: 'Layout da Pesquisa',
      editorLanguage: 'pt_BR',
      sender: 'Remetente',
      feedbackSender: 'Informe o remetente',
      subjectMatter: 'Assunto',
      template: 'Template',
      buttonAddTemplate: 'Adicionar template',
      topLogo: 'Logo superior',
      changeLogo: 'Escolher outro logo',
      buttonChooseFile: 'Escolher arquivo',
      noFileSelected: 'Nenhum arquivo selecionado',
      closingMessageInput: 'Msg de encerramento',
      privacyPolicyInput: 'Política de privacidade',
      anonymousResponseInput: 'Resposta anônima',
      anonymousSwitch: 'Habilitar anônimo',
      alwaysAnonymousSwitch: 'Habilitar sempre anônimo',
      addEmail: 'Adicionar e-mail',
      sendTestEmail: 'Enviar',
      modalTestSurvey:
        'Valide seu layout antes do envio para seus clientes! Preencha seu e-mail e veja como seus clientes irão receber o seu e-mail customizado.',
      footerInput: 'Rodapé',
      scale0a10:
        'Em uma escala de 0 a 10, quanto você indicaria a {companyName} para um amigo ou familiar?',
      scale1a5:
        'Em uma escala de 1 a 5, quanto você indicaria a {companyName} para um amigo ou familiar?',
      scaleCES1a5:
        'Em uma escala de 1 a 5, onde 1 é "muito difícil" e 5 é "muito fácil", o quão fácil foi se relacionar com a nossa empresa?',
      scaleCSAT1to5:
        'Em uma escala de 1 a 5, qual sua satisfação com a nossa empresa?',
      scaleCSAT0to10:
        'Em uma escala de 0 a 10, qual sua satisfação com a nossa empresa?',
      question5Stars: 'Como você classifica nosso atendimento prestado?',
      questionLikeDislike:
        'Como você classifica sua experiência com o serviço prestado?',
      newTemplateEmail: 'Novo Template de Email',
      selectSavedTemplate: 'Selecionar template salvo',
      feedbackSaveTemplate: 'Informe um nome para salvar o seu template',
      enterNameTemplate: 'Informe um nome para o template',
      saveButton: 'Salvar',
      createdSucess: 'Template criado com sucesso.',
      cancelButton: 'Cancelar',
      preview: 'Preview',
      scaleNps0a10: 'NPS - escala de 0 a 10',
      scaleNps1a5: 'NPS - escala de 1 a 5',
      editButton: 'Editar',
      titleTestLayoutEmail: 'Testar Layout de E-mail',
      bodyButtonMsg: 'O botão abaixo aparecerá somente no corpo do e-mail.',
      rateExperience: 'Avalie sua experiência!',
      enterSubject: 'Informe um assunto',
      scaleButton: 'Escala',
      scaleBorder: 'Bordas',
      scaleGrade: 'Texto botão',
      scaleLargeButton: 'Botão',
      scaleButtonselected: 'Seleção',
      scaleBackground: 'Fundo',
      scaleBackgroundText: 'Textos',
      scaleActiveText: 'Texto botão selecionado',
      messageError: {
        title: 'Oops! Algo deu errado...',
        description:
          'Sua empresa não possui uma Política de Privacidade. Salve sua ação e navege até o menu configurações para cadastrá-la.',
        errorEditAction:
          'Algo deu errado no momento da edição da ação. Por favor, verifique os dados e tente novamente.',
        errorCreateAction:
          'Algo deu errado no momento da criação da ação. Por favor, verifique os dados e tente novamente.',
        errorExceed: 'Mensagem atingiu o limite de caracteres',
      },
      testEmail: {
        title: 'Sucesso',
        description: 'E-mail teste enviado com sucesso!',
      },
      invalidEmail: {
        title: 'Falha',
        description: 'Informe um e-mail válido',
      },
      failedSendEmail: {
        title: 'Falha',
        description: 'Envio de teste falhou',
      },
      deleteItem: {
        title: 'Aviso',
        description:
          'Você está prestes a excluir este item, tem certeza que quer continuar?',
      },
      titleClosingMessage: 'Layout de encerramento',
      titleAutomaticAnswer: 'Template automático',
      enableSMS: 'Habilitar resposta via SMS?',
      smsMessage:
        'Em uma escala de 0 a 10, qual nota você atribui a nossa empresa?',
      feedbackInformQuestionSMS:
        'Por favor, informe a pergunta que será enviada por sms.',
      feedbackEnterQuestion:
        'Por favor, informe uma pergunta ou remova este campo.',
      numMaxQuestions: 'Você atingiu o número máximo de perguntas adicionais.',
      feedbackEnterOneQuestion: 'Por favor, informe uma pergunta.',
      clickHere: 'Clique aqui para acessar.',
      metrics: 'Métricas',
      review: 'Review',
      csat0a10: 'Escala 0 a 10',
      likert1a5: 'Likert - 1 a 5',
      likeDislike: 'Like/Dislike',
      emotion: 'Emotion',
      csat: 'Escala 0 a 10',
      likert: 'Likert',
      multipleChoices: 'Multipla escolha',
      text: 'Texto',
      registrationData: 'Dados cadastrais',
      label: 'Rótulo',
      multipleChoiceModal: {
        other: 'Outros',
        enableOther: 'Habilitar opção "outros" (Campo Aberto)',
        title: 'Opção de resposta múltipla',
        description:
          'Preencha o tipo de resposta única ou multipla escolha e as opções de respostas.',
        newOption: 'Opção {option}',
        singleChoice: 'Escolha única',
        multipleChoice: 'Escolha múltipla',
      },
      allAnswersRequired: 'Todas respostas obrigatórias',
      customMandatoryQuestions: 'Respostas obrigatórias por pergunta adicional',
      widget: {
        type: 'Tipo do widget',
        allowedDomain: 'Domínio que utilizará o widget',
        scriptLabel: 'Script para ser inserido em sua plataforma',
        name: 'Nome',
        phone: 'Telefone',
        indicators: 'Indicadores',
        copy: 'Copiar',
        simulate: 'Simular',
        copiedTitle: 'Script copiado',
        copiedDescription: 'O script foi copiado para a área de transferência!',
        comment:
          'Apenas os campos "name", "email", "phone" e "indicators" podem ser alteradas no código acima. Eles são responsáveis pela identificação do cliente.',
        disabled: 'Pausar widget',
        paused: 'Widget pausado!',
      },
      questionFormatting: 'Exibição das perguntas (Formatação)',
      default: 'Padrão',
      custom: 'Personalizado',
      defaultDescription:
        'Alinha e centraliza as perguntas adicionais no meio da página. Verificar no preview.',
      customDescription:
        'Alinha a direita da página as perguntas adicionais. Verificar no  preview.',
      typeQuestionLikert: 'Tipo de pergunta likert:',
      satisfied: 'Satisfação',
      agreement: 'Concordância',
      frequency: 'Frequência',
      importance: 'Importância',
      probability: 'Probabilidade',
      viewLikertSelected: 'Visualização de pergunta likert selecionada:',
    },
    stepTwo: {
      labels: {
        amount: 'Quantidade',
        schedule: 'Horário',
        intervalDays: 'Intervalo em dias',
        type: 'Tipo',
        periodDays: ' Período em dias',
        expirationDays: 'Expiração em dias',
        titleAlert: 'Título do Alerta',
        ruleName: 'Nome da Regra',
        creationDate: 'Data de criação',
        actions: 'Ações',
      },
      enableSMS: 'Habilitar lembrete por SMS?',
      msgReminder:
        'Quando habilitado todo lembrete será enviado também via SMS. É necessário ter saldo de SMS disponível!',
      msgReminderEmailSms:
        'Quando habilitado todo lembrete será enviado por E-mail e SMS. É necessário ter saldo de SMS disponível',
      typeMesssage: 'Digite a mensagem para o link do lembrete',
      mandatory: 'Obrigatório',
      titleSetting: 'CONFIGURAÇÃO DE ALERTAS E TRATATIVAS',
      titleQuarantineSetting: 'CONFIGURAÇÃO DE QUARENTENA',
      titleExpirationDate: 'DATA DE EXPIRAÇÃO',
      titleModelAlert: 'MODELO DE ALERTAS',
      selectedRule: 'Regra Selecionada',
      noRule: 'Nenhuma',
      noOption: 'Nenhum',
      newRule: 'Nova regra',
      shoot: 'Disparo',
      answer: 'Resposta',
      actionGroup: 'Grupo de Ações',
      reminderSetting: 'CONFIGURAÇÃO DE LEMBRETES',
      feedbackEnterAlertName: 'Por favor, informe o nome do alerta.',
      infoAlert: 'O alerta será recebido no idioma respondido pelo cliente',
      feedbackNewAlert: 'Você recebeu um novo alerta!',
      feedbackIncorrectProduct:
        'Não recebi o produto correto e estou bem chateado!',
      note: 'Nota',
      action: 'Ação',
      channel: 'Canal',
      phone: 'Telefone',
      email: 'E-mail',
      feedbackUserReport: 'O usuário abaixo reportou o seguinte feedback',
      message: 'Mensagem',
      emailJoao: 'joao@gmail.com',
      phoneUser: '(19)99854-1365',
      languageEmail: 'Idioma do e-mail',
    },
    stepThree: {
      actionPaused: 'Não é possível enviar porque a ação está pausada!',
      labels: {
        addIndicators: 'Adicionar indicadores',
        personName: 'Nome',
        personEmail: 'E-mail',
        personPhone: 'Telefone',
      },
      titleIndicators: 'Indicadores',
      titleLayout: 'LAYOUT DO ARQUIVO',
      titleClearTable: 'Limpar tabela de clientes',
      titleImportData: 'IMPORTAR DADOS',
      titleInsertCustomer: 'Inserir cliente',
      titleScheduling: 'AGENDAMENTO',
      titleAddIndicator: 'Inclusão de Indicador',
      shootNow: 'Disparar agora',
      scheduleShooting: 'Agendar disparo',
      shoot: 'Disparar',
      toSchedule: 'Agendar',
      settingsSaved: 'Configurações da Ação Salvas!',
      skipImport: 'Avançar Para Importação',
      wish: 'O que você deseja fazer agora?',
      continueAfter: 'Continuar Depois',
      cancel: 'Cancelar',
      importCustomersXLS: 'Importar clientes via arquivo XLS',
      informFieldName: 'Informe o campo {nameField}',
      informFieldEmail: 'Informe o campo {emailField}',
      informFieldPhone: 'Informe o campo {emailPhone}',
      failedAddCustomer: 'Falha ao incluir cliente.',
      importFile: 'Importar arquivo',
      dragFile: 'Clique aqui ou arraste o arquivo até aqui',
      dropFile: 'Solte o arquivo aqui...',
      insertCustomers: 'Inserir clientes manualmente',
      enterIndicatorsName: 'Digite o nome do indicador',
      itens: 'Itens',
      buttonAddColumn: 'Adicionar',
      downloadModelButton: 'Baixar modelo',
      addedIndicators: 'Indicadores adicionados',
      indicator: 'Indicador',
      remove: 'Remover',
      generateQrCode: 'Geração do Qr Code',
      uniqueQrCode: 'QR Code único',
      uniqueQrCodeDescription:
        'Com o código gerado, seu cliente poderá scanear através da câmera do celular e ser direcionado para a página da pesquisa. Este modelo é ideal para casos de pesquisas mais simples, que não existe a necessidade de identificar um determinado produto ou serviço.',
      multipleQrCode: 'QR Code múltiplo',
      multipleQrCodeDescription:
        'Com o código gerado, seu cliente poderá scanear através da câmera do celular e ser direcionado para a página da pesquisa. Este modelo é ideal para casos de pesquisas onde existe a necessidade de geração de vários QR Codes para uma mesma ação e que existe necessidade de identificar um determinado produto, serviço ou unidade com códigos diferentes.',
      downloadQrCode: 'Download QR Code',
      importValueQrCode: 'Importar valor via arquivo XLS',
      enterValueManually: 'Inserir valor manualmente',
      generateQrCodeButton: 'Gerar QR Code',
      viewQrCodes: 'Visualizar QR Codes gerados',
      generatedQRCodes: 'QR Codes gerados',
      descriptionGeneratedQrCodes:
        'Abaixo a lista de todos os códigos gerados que poderão ser utilizados para sua pesquisa.',
      backListActions: 'Voltar para lista de ações',
      savedQrCodes: 'QR Codes salvos!',
      invalidIdField:
        'Não é possível incluir um campo com o nome id para o QR Code.',
      deleteQrcode: 'Deletar QR Code',
      deleteQrcodeDescription:
        'Tem certeza que deseja deletar o QR Code? Não será mais possível responder pesquisas através desse link.',
      qrcodeTableOptions: 'Opções',
      indicatorHeaders: {
        filial: {
          header: 'Filial',
          content:
            'Nome de Lojas, filiais, unidades. Este indicador pode ser utilizado para hierarquia de usuários atribuindo permissão para determinadas filiais.',
        },
        ih2: {
          header: 'IH2',
          content:
            'Indicador de hierarquia 2 (IH2) pode ser utilizado para departamentos, grupos, etc, sendo que sua principal função é atribuição de permissão por usuário.',
        },
        report: {
          header: 'Relatório',
          content:
            'Indicadores tipo relatório são indicadores que serão utilizados para análise detalhada em relatórios, criando quebras nos relatórios de acordo com os dados deste indicador.',
        },
        map: {
          header: 'Mapa',
          content:
            'Tipo Mapa deve ser preenchido com dados de UF (estado) com duas letras, este indicador preencherá um mapa de cor de acordo com a nota principal e estado brasileiro.',
        },
        date: {
          header: 'Data',
          content:
            'Indicador tipo data deve ser selecionado neste tipo para que fique com o formato correto dd/mm/aaaa',
        },
        auxiliary: {
          header: 'Auxiliar',
          content:
            'Indicadores para visualização em detalhes porém sem quebra por relatório, ex: numero nota fiscal, cnpj cliente, código cliente, datas, etc. são indicadores que não utilizaremos para visões de relatórios.',
        },
        clientId: {
          header: 'Client ID',
          content:
            'Chave de identificação única do cliente, como: CPF, RG, ID, CNPJ etc.',
        },
        expiration: {
          header: 'Data Expiração',
          content:
            'Indicador tipo Data de Expiração deve ser preenchido no formato dd/mm/aaaa',
        },
      },
      messages: {
        warning: {
          title: 'Atenção!',
          description:
            'O disparo foi realizado apenas via {channel1}. Você não possui saldo suficiente para disparar via {channel2}. Favor contatar o time de CS do IndeCX para maiores informações.',
        },
        exceeded: {
          title: 'Saldo insuficiente!',
          description:
            'Saldo insuficiente para disparo! Você está tentando disparar {totalInvites} convites e possui {balanceMsg} de saldo. Favor contatar o time de CS do IndeCX para maiores informações.',
        },
        shots: {
          title: 'Disparo Configurado!',
          description:
            'Você será redirecionado para sua lista de ações para acompanhar o status do disparo.',
        },
        dangerMode: {
          title: 'Oops... Algo deu errado!',
          description:
            'Houve um problema ao adicionar esse tipo para o indicador.',
        },
        removeColumn: {
          title: 'Desativar indicador',
          description: 'Tem certeza de que deseja desativar este indicador?',
        },
        errorMessage: {
          title: 'Erro ao incluir cliente',
          description: 'Houve um erro ao processar sua requisição.',
        },
        success: {
          title: 'Sucesso!',
          description: 'O indicador foi desativado!',
        },
        deleteList: {
          title: 'Excluir Lista',
          description: 'Tem certeza que deseja excluir essa lista de clientes?',
        },
        emailInvalid: {
          title: 'Email inválido',
          description: 'Por favor, digite um email válido.',
        },
        addClientSuccess: {
          title: 'Sucesso',
          description: 'Cliente adicionado com sucesso!',
        },
        errors: {
          invalidColumn: 'Não é possível ter duas colunas com o mesmo nome.',
          invalidNumber: 'Por favor, insira um número válido para o cliente.',
          invalidCharacters: 'Caracteres . e $ não permitidos no nome',
        },
      },
    },
  },
  actionGroup: {
    pageTitle: 'Grupo de ações',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    groupTable: {
      labels: {
        id: 'ID',
        name: 'Nome',
        metric: 'Métrica',
        favourite: 'Favorito',
        actions: 'Ações associadas',
        options: 'Opções',
      },
    },
    newGroupButton: 'Novo grupo',
    editGroup: 'Editar grupo',
    newGroup: 'Novo grupo',
    save: 'Salvar',
    groupName: 'Nome do Grupo',
    placeholderGroupName: 'Digite o nome do grupo',
    metric: 'Métrica',
    favoriteGroup: 'Grupo Favorito',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    ces15: 'CES 1 a 5',
    csat15: 'CSAT 1 a 5(Top 2 box)',
    csatAverage15: 'CSAT 1 a 5(Média)',
    csat0to10Average: 'CSAT 0 a 10(Média)',
    fiveStars: '5-Stars',
    likeDislike: 'Like/Dislike - 0 e 1',
    messages: {
      saveError: {
        title: 'Oops...',
        description: 'Por favor, inserir um nome para o grupo.',
      },
      edited: {
        title: 'Grupo editado!',
        description: 'Grupo editado com sucesso!',
      },
      created: {
        title: 'Grupo cadastrado!',
        description: 'Novo grupo cadastrado com sucesso!',
      },
      favorite: {
        title: 'Tem certeza?',
        description1: 'Deseja desfavoritar o grupo',
        description2: 'Deseja favoritar o grupo',
      },
      favoriteOk: {
        title1: 'Grupo desfavoritado!',
        title2: 'Grupo favoritado!',
        description1: 'Grupo não é mais o seu favorito.',
        description2: 'Grupo se tornou o seu favorito.',
      },
      deleted: {
        title: 'Tem certeza?',
        description: 'Deseja grupo o grupo',
      },
      deletedOk: {
        title: 'Grupo deletado!',
        description: 'O grupo foi deletado.',
      },
    },
  },
  answers: {
    pageTitle: 'Respostas',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    email: 'Email',
    telephone: 'Telefone',
    channel: 'Canal',
    comment: 'Quer deixar algum comentário?',
    action: 'Ação',
    metric: 'Métrica',
    exportCsv: 'Exportar para CSV',
    exportXls: 'Exportar para XLSX',
    csvCommaSeparator: 'Separar por vírgula',
    csvPipeSeparator: 'Separar por pipe',
    analyticsDownload: 'Analítico BI',
    categoriesDownload: 'Categorias',
    answersDownload: 'Respostas',
    feedbackEdited: 'Comentário editado por {feedbackEditedAutor}',
    editComment: 'Editar Comentário',
    editComentary:
      'Você pode editar o comentário do cliente para adicionar alguma consideração ao texto.',
    nobody: 'Ninguem',
    addQuestions: 'Perguntas Adicionais',
    details: 'Detalhes',
    removeAnswer: 'Excluir Resposta',
    cancel: 'Cancelar',
    remove: 'Remover',
    removeSuccess: 'Resposta deletada com sucesso!',
    ops: 'Oops...',
    categorization: 'Categorização',
    categorizationGol: 'Categorização Adicional',
    infoAnswer: 'Informação',
    gradeAnswer: 'Nota',
    ratingAnswer: 'Avaliação',
    foundAnswer: 'respostas encontradas',
    nameAnswer: 'Nome',
    emailAnswer: 'Email',
    phoneAnswer: 'Telefone',
    channelAnswer: 'Canal',
    actionAnswer: 'Ação',
    metricAnswer: 'Métrica',
    feedbackAnswer: 'Feedback',
    categoryAnswer: 'Categoria',
    nextAnswer: 'Próxima resposta',
    previousAnswer: 'Resposta anterior',
    noAnswersFound: 'Nenhuma resposta encontrada.',
    donwload: {
      title: 'Sucesso!',
      description:
        'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
    },
    deleteAnswer: {
      title: 'Remover Resposta',
      description:
        'Tem certeza que deseja remover essa resposta? Isso pode afetar diretamente o calculo do seu NPS.',
    },
    deleteCategory: {
      title: 'Remover Categoria',
      description: 'Tem certeza que deseja remover essa categoria?',
    },
    categoryDelSuccess: 'Categoria removida com sucesso!',
    profileSelect: {
      select: 'Filtro por perfil',
      all: 'Todos',
      neutral: 'Neutros',
      detractors: 'Detratores',
      promoters: 'Promotores',
    },
    channelSelect: {
      select: 'Filtro por canal',
      all: 'Todos',
      email: 'Email',
      sms: 'SMS',
      link: 'Link',
      qrcode: 'QR-Code',
      manual: 'Manual',
      widget: 'Widget',
      whatsapp: 'Whatsapp',
      treatmentTags: 'Tags Tratativas',
    },
    categorySelect: {
      select: 'Filtro por categoria',
      all: 'Todas',
      empty: 'Sem categoria (vazio)',
    },
    responsibleSelect: 'Selecione o responsável',
    notificationSelect: 'Selecione',
    filterOptions: {
      select: 'Selecione o filtro',
      profile: 'Perfil',
      status: 'Status',
      category: 'Categoria',
      responsible: 'Responsável',
      notification: 'Notificação',
      audio: 'Áudio',
      channel: 'Canal',
      comments: 'Comentário',
      anonymous: 'Anônimo',
      yes: 'Sim',
      no: 'Não',
      treatmentTags: 'Tags Tratativas',
      addQuestion: 'Pergunta adicional',
      sentiment: 'Sentimento',
      partial: 'Resposta parcial',
      recordedAudio: 'Áudio gravado',
    },
    sentiment: {
      positive: 'Positivo',
      negative: 'Negativo',
      neutral: 'Neutro',
    },
    notificationSelects: {
      viewed: 'Visualizado',
      noViewed: 'Não visualizado',
    },
    commentsSelect: {
      select: 'Filtro por comentário',
      all: 'Todas',
      withComments: 'Somente com comentário',
      noComments: 'Somente sem comentário',
    },
    anonymousSelect: {
      select: 'Selecione um filtro',
      all: 'Todas',
      anonymous: 'Anônimo',
      yes: 'Sim',
      no: 'Não',
    },
    recordedAudio: {
      select: 'Selecione um filtro',
      all: 'Todas',
      anonymous: 'Anônimo',
      yes: 'Sim',
      no: 'Não',
    },
    audioSelected: {
      select: 'Selecione um filtro',
      all: 'Todas',
      yes: 'Sim',
      no: 'Não',
    },
    justCommentsLable: 'Apenas com comentário',
    answerTable: {
      labels: {
        id: 'ID',
        date: 'Data',
        grade: 'Nota',
        client: 'Cliente',
        comment: 'Comentário',
        category: 'Categorias',
        options: 'Opções',
        tags: 'Tags',
      },
    },
    answersDetails: {
      details: 'Detalhes',
      historic: 'Histórico de',
      note: 'Nota',
      channel: 'Canal',
      action: 'Ação',
      comment: 'Comentário',
      search: 'Faça sua busca...',
      transferSuccess: 'Transferência realizada com sucesso!',
      transferError: 'Erro em Transferência',
      transferErrorMessage:
        'Hubo un error en la transferencia. Inténtalo de nuevo en un momento.',
      branchSearchDescription:
        'Você pode transferir uma pesquisa entre filiais caso necessário. Selecione abaixo para qual filial deseja transferir essa pesquisa.',
      actionDescription:
        'Você pode transferir uma pesquisa entre ações que possuem a mesma métrica principal como base caso necessário. Selecione abaixo para qual ação deseja transferir essa pesquisa.',
      transferFactoryAccount: 'Transferir para conta de fábrica',
      transferAffiliateSearch: 'Transferir pesquisa de filial',
      transferBetweenShares: 'Transferir pesquisa de ação',
      sentimentAnalyze: 'Análise de Sentimento',
      sentimentMsg:
        'A IndeCX utiliza Inteligência Artificial para classificação do sentimento e extração de palavras-chaves com base nos comentários. O score abaixo indica o nível do sentimento, podendo variar de -100 até 100.',
      sentiment: 'Sentimento',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
      keywords: 'Keywords',
      email: 'E-mail',
      phone: 'Telefone',
      date: 'Data',
      categories: 'Categorias',
      indicators: 'Indicadores',
      none: 'Nenhum',
      additionalQuestions: 'Perguntas adicionais',
      treatments: {
        status: 'Status',
        responsible: 'Responsável',
        changeStatus: 'Alterar Status',
        selectOpenStatus: 'Aberto',
        selectAnalisysStatus: 'Em análise',
        selectEscalatedStatus: 'Escalonado',
        selectAnsweredStatus: 'Respondido',
        changeResponsible: 'Alterar Responsável',
        veryUnsatisfied: 'Muito insatisfeito',
        dissatisfied: 'Insatisfeito',
        indifferent: 'Indiferente',
        satisfied: 'Satisfeito',
        verySatisfied: 'Muito Satisfeito',
        anonymous: 'Anônimo',
        noName: 'Sem Nome',
        back: 'Voltar',
        feed: 'Feed',
        updateTemplate: 'Atualizar template',
        deleteTemplate: 'Deletar template',
        addCommentary: 'Adicionar comentário',
        nobody: 'Ninguém',
        dataAction: 'Dados da ação',
        treatment: 'Tratativas',
        treatmentTabLabel: 'TRATATIVAS',
        answerTabLabel: 'RESPONDER',
        selectFilterTreatments: 'Selecione o filtro',
        systemAlert: 'Alerta do sistema',
        commentFilterTreatments: 'Comentário',
        statusFilterTreatments: 'Status',
        responsibleFilterTretaments: 'Responsável',
        allFilterTreatments: 'Todos',
        mostRecent: 'Mais recente',
        mostOld: 'Mais antigo',
        to: 'Para',
        subject: 'Assunto',
        from: 'Remetente',
        template: 'Template',
        send: 'Enviar',
        swAdd: {
          title: 'Comentário Adicionado!',
          description: 'Seu comentário foi adicionado a essa tratativa',
        },
        swAddError: {
          title: 'Oops! Algo deu errado!',
          description: 'Tente novamente mais tarde!',
        },
        swSave: {
          title: 'Sucesso!',
          description: 'As infomações adicionais foram salvas com sucesso!',
        },
        swResponsible: {
          title: 'Responsável Alterado!',
          description: 'Um novo responsável foi marcado para essa tratativa.',
        },
        swStatus: {
          title: 'Status Alterado!',
          description: 'O status dessa tratativa foi alterado para',
        },
        swExceededQuantity: {
          title: 'Limite de arquivos atingido!',
          description: 'A quantidade máxima de 5 arquivos foi atingida.',
        },
        enterContact: 'Entrou em contato com o cliente',
        yes: 'Sim',
        no: 'Não',
        whatChannel: 'Por qual canal o contato foi realizado?',
        wpp: 'Whatsapp',
        phone: 'Telefone',
        email: 'Email',
        personally: 'Pessoalmente',
        others: 'Outros',
        caseDifficult:
          'Caso teve dificuldades com as peças desse atendimento, por favor informar:',
        saveInfo: 'Salvar informações',
        pieceNumber: 'Número da peça',
        pieceName: 'Nome da peça',
        price: 'Preço',
      },
    },
    filterTypeOptions: {
      email: 'Email',
      id: 'ControlID',
      name: 'Nome',
      phone: 'Telefone',
      feedback: 'Comentário',
      clientId: 'ClientID',
    },
    entirePeriodWarning: {
      title: 'Atenção!',
      description: 'Por favor, insira um período menor.',
    },
  },
  manualAnswer: {
    pageTitle: 'Pesquisa manual',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    invitesTable: {
      labels: {
        id: 'ID',
        action: 'Ação',
        client: 'Cliente',
        submit: 'Envio',
        reminder: 'Lembrete',
        days: 'Dias',
        channel: 'Canal',
        status: 'Status',
        manual: 'Resposta manual',
      },
    },
    metric: 'Métrica',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    ces15: 'CES 1 a 5',
    csat15: 'CSAT 1 a 5 (Top 2 box)',
    csatAverage15: 'CSAT 1 a 5 (Média)',
    csat0to10Average: 'CSAT 0 a 10 (Média)',
    likeDislike: 'Like/Dislike - 0 e 1',
    fiveStars: '5-Stars',
    noName: 'Sem Nome',
    email: 'E-mail',
    phone: 'Telefone',
    both: 'ambos',
    active: 'Ativo',
    expired: 'Expirado',
    updateInvite: 'Atualizar convite',
    noInvite: 'Convite não disponível.',
    messages: {
      refresh: {
        title: 'Reativar Convite',
        description: 'Tem certeza que deseja reativar o convite do cliente?',
        okLabel: 'Reativar',
        cancelLabel: 'Cancelar',
      },
      answeredSearch: {
        title: 'Pesquisa Respondida',
        description: 'A pesquisa foi respondida manualmente para o cliente.',
      },
      unansweredSurvey: {
        title: 'Pesquisa não respondida',
        description: 'Por favor, insira uma nota de 0 a 10.',
      },
      required: 'Por favor, responda todas as perguntas obrigatórias.',
    },
  },
  sentiment: {
    pageTitle: 'Análise de Sentimento',
    sentimentSelect: {
      select: 'Filtro por sentimento',
      all: 'Todos',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
    },
    table: {
      sentiment: 'Reação',
      score: 'Sentimento',
      keywords: 'Palavras Chave',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
      options: 'Visualizar',
    },
  },
  clients: {
    pageTitle: 'Clientes',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    exportCsv: 'Exportar para CSV',
    exportXls: 'Exportar para XLS',
    csvCommaSeparator: 'Separar por vírgula',
    csvPipeSeparator: 'Separar por pipe',
    messages: {
      export: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
      },
      error: {
        title: 'Oops...',
      },
      entirePeriodWarning: {
        title: 'Atenção!',
        description: 'Por favor, insira um período menor.',
      },
    },
    clientsTable: {
      labels: {
        id: 'ID',
        name: 'Nome',
        email: 'Email',
        phone: 'Telefone',
        lastAction: 'Ação',
        lastImportation: 'Importação',
        lastInvite: 'Último convite',
        lastAnswer: 'Última resposta',
        status: 'Status',
        answered: 'Respondido',
        lastReminder: 'Último Lembrete',
        reminders: 'Lembretes',
        editReminder: 'Editar',
      },
      searchOptions: {
        email: 'Email',
        id: 'ControlID',
        name: 'Nome',
        phone: 'Telefone',
        clientId: 'ClientID',
      },
      answeredYes: 'Sim',
      answeredNo: 'Não',
      statusYes: 'Ativo',
      statusNo: 'Inativo',
    },
  },
  quarentines: {
    pageTitle: 'Quarentena',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    totalQuarentine: 'Total de clientes em quarentena',
    exportCsv: 'Exportar para CSV',
    exportXls: 'Exportar para XLS',
    csvCommaSeparator: 'Separar por vírgula',
    csvPipeSeparator: 'Separar por pipe',
    messages: {
      export: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
      },
      error: {
        title: 'Oops! Algo deu errado!',
        description: 'Tente novamente mais tarde!',
      },
      removeOk: {
        title: 'Sucesso!',
        description: 'Exclusão realizada com sucesso',
      },
      removeQuarentine: {
        title: 'Remover quarentena',
        description: 'Tem certeza de que deseja excluir essa quarentena?',
        ok: 'Quarentena excluída com sucesso',
      },
    },
    action: 'Ação',
    company: 'Empresa',
    quarentinesTable: {
      labels: {
        email: 'E-mail',
        phone: 'Telefone',
        clientId: 'ClientId',
        type: 'Tipo',
        action: 'Ação',
        quarentineDate: 'Data Quarentena',
        expireDate: 'Expira em',
        actions: 'Ações',
      },
    },
  },
  blacklist: {
    totalBlacklist: 'Total de clientes em blocklist',
    addClient: 'Adicionar cliente',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    pageTitle: 'Blocklist',
    labelsTable: {
      email: 'E-mail',
      phone: 'Telefone',
      controlId: 'ControlId',
      action: 'Ação',
      reason: 'Motivo',
      blackListDate: 'Data Blocklist',
      actions: 'Ações',
      channel: 'Canal',
    },
    exportCsv: 'Exportar para CSV',
    exportXls: 'Exportar para XLS',
    csvCommaSeparator: 'Separar por vírgula',
    csvPipeSeparator: 'Separar por pipe',
    messages: {
      export: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
      },
      error: {
        title: 'Oops! Algo deu errado!',
        description: 'Tente novamente mais tarde!',
      },
      removeOk: {
        title: 'Sucesso!',
        description: 'Exclusão realizada com sucesso',
      },
      removeBlackList: {
        title: 'Remover blacklist',
        description: 'Tem certeza de que deseja excluir essa blacklist?',
        ok: 'Blacklist excluída com sucesso',
      },
    },
  },
  downloads: {
    pageTitle: 'Meus downloads',
    clients: 'Clientes',
    answers: 'Respostas',
    invites: 'Convites',
    invitesStatus: 'Status Disparo',
    answerIndicators: 'Respostas (Indicador)',
    reminders: 'Lembretes',
    scheduling: 'Agendamentos',
    trash: 'Lixeira',
    answerDetails: 'Detalhes da ação',
    quarentine: 'Quarentena',
    blackList: 'BlockList',
    analytics: 'Analítico BI',
    category: 'Categorias',
    consumption: 'Consumo',
    action: 'Ações',
    downloading: 'downloading',
    internalError: 'Erro interno.',
    fileNotFound: 'Arquivo não encontrado.',
    errorTitle: 'Oops...',
    finished: 'concluido',
    downloadsTable: {
      labels: {
        id: 'ID',
        date: 'Data',
        type: 'Tipo',
        extension: 'Extensão',
        status: 'Status',
        file: 'Arquivo',
      },
    },
    invalidDownload: {
      title: 'Arquivo indisponível!',
      description:
        'O arquivo não existe mais. Por favor, gere outro download e tente novamente.',
    },
  },
  uploads: {
    pageTitle: 'Meus uploads',
    errorTitle: 'Oops...',
    fillFields: 'Favor preencher todos os campos',
    sendFile: 'Enviar Arquivo',
    modalTitle: 'Enviar Arquivo',
    branchLabel: 'Selecione a Filial',
    referenceLabel: 'Referência do Arquivo',
    actionLabel: 'Selecione a Ação',
    fileLabel: 'Selecione o Arquivo',
    attachFile: 'Anexar arquivo',
    indicatorsError: 'Formato de arquivo incorreto',
    notificationTitle: 'Importante',
    notificationText: `O sistema de upload somente aceita arquivos com o mesmo
      layout da ação selecionada. Verifique se o arquivo utilizado
      contém a mesma quantidade de colunas e se ordem das colunas
      estão de acordo com o configurado anteriormente da ação.`,
    selectReferenceLabel: 'Tipo',
    referenceSales: 'Vendas',
    referenceAftersales: 'Pós-vendas',
    selectLabel: 'Selecionar',
    selectPlaceholder: 'Selecione arquivo ou arraste aqui...',
    dropPlaceholder: 'Arraste o arquivo até aqui',
    uploadsTable: {
      labels: {
        id: 'ID',
        user: 'Usuário',
        date: 'Data',
        file: 'Arquivo',
        branch: 'Filial',
        action: 'Ação',
        reference: 'Referência',
        options: 'Opções',
        remove: 'Remover',
        download: 'Download',
      },
    },
    uploadOk: 'Upload realizado com sucesso',
    removeUpload: {
      title: 'Remover arquivo',
      description: 'Tem certeza de que deseja remover esse arquivo?',
      ok: 'Arquivo removido com sucesso',
    },
  },
  resend: {
    pageTitle: 'Reenviar pesquisa (convites ativos)',
    pageTitlewpp: 'Disparo manual de convites por Whatsapp',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    selectPage: 'Selecionar página',
    selectsInfo: {
      clientsLength: 'Foram selecionados {length} clientes para reenvio.',
      selectAll: 'Selecionar todos os {length} clientes.',
      allClients: 'Todos os {length} foram selecionados.',
      cleanSelection: 'Limpar seleção.',
    },
    invitesTable: {
      labels: {
        id: 'ID',
        action: 'Ação',
        client: 'Cliente',
        submit: 'Envio',
        resend: 'Último reenvio',
        reminder: 'Lembrete',
        days: 'Dias',
        channel: 'Canal',
        link: 'Link',
        select: 'Selecionar',
        message: 'Mensagem',
        copy: 'Copiar',
        lastSend: 'Último disparo',
      },
    },
    cancelInvitesButton: 'Cancelar convites',
    resendButton: 'Reenviar',
    metric: 'Métrica',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    noName: 'Sem Nome',
    email: 'E-mail',
    phone: 'Telefone',
    both: 'ambos',
    copyLink: 'Copiar Link',
    exportCsv: 'Exportar para CSV',
    exportXls: 'Exportar para XLS',
    sendWpp: 'Reenviar via WhatsApp',
    whatsappWebMsg: 'Enviar link de pesquisa automatizada via WhatsApp',
    send: 'Enviar',
    name: 'Nome',
    messages: {
      copyUrl: {
        title: 'Link Copiado',
        description:
          'O link do cliente foi copiado para a área de transferência.',
      },
      copyMsg: {
        title: 'Mensagem Copiada',
        description: 'A mensagem foi copiada para a área de transferência.',
      },
      sendNoClient: {
        title: 'Nenhum Cliente Selecionado',
        description:
          'Você deve selecionar ao menos um cliente para reenviar a pesquisa.',
      },
      sendAllInvites: {
        title: 'Reenviar Pesquisa',
        description:
          'Tem certeza que deseja reenviar a pesquisa para todos os clientes selecionados?',
        yesLabel: 'Sim',
        noLabel: 'Não',
        sentMsg1: 'A pesquisa foi reenviada com sucesso para',
        sentMsg2: 'cliente(s) de',
        sentMsg3: 'selecionado(s)!',
        sentMsgOk:
          'A pesquisa foi reenviada com sucesso para o(s) cliente(s) selecionado(s)!',
      },
      sendInvites: {
        title: 'Reenviar Pesquisa',
        description1: 'Tem certeza que deseja reenviar a pesquisa para',
        description2: 'cliente(s)',
        yesLabel: 'Sim',
        noLabel: 'Não',
        sentMsg1: 'A pesquisa foi reenviada com sucesso para',
        sentMsg2: 'cliente(s) de',
        sentMsg3: 'selecionado(s)!',
        sentMsgOk:
          'A pesquisa foi reenviada com sucesso para o(s) cliente(s) selecionado(s)!',
      },
      warning: {
        title: 'Atenção!',
        description:
          'O disparo foi realizado apenas via {channel1}. Você não possui saldo suficiente para disparar via {channel2}. Favor contatar o time de CS do IndeCX para maiores informações.',
      },
      quotaError: {
        title: 'Saldo insuficiente!',
        description:
          'Você não possui saldo suficiente para disparar via {channel}. Favor contatar o time de CS do IndeCX para maiores informações.',
      },
      noQuota: {
        title: 'Saldo insuficiente!',
        description1:
          'Saldo insuficiente para envío! usted está intentando enviar',
        description2: 'invitaciones y tiene',
        description3:
          'de saldo. Por favor contactar el equipo de CS de IndeCX para mayores informaciones',
        description:
          'Saldo insuficiente para disparo! Você está tentando disparar {totalInvites} convites e possui {balanceMsg} de saldo. Favor contatar o time de CS do IndeCX para maiores informações.',
      },
      cancelNoClient: {
        title: 'Nenhum Cliente Selecionado',
        description:
          'Você deve selecionar ao menos um convite para cancelamento.',
      },
      cancelAllInvites: {
        title: 'Cancelar convites',
        description:
          'Tem certeza que deseja cancelar os convites para todos os clientes selecionados?',
        yesLabel: 'Sim',
        noLabel: 'Não',
        cancelMsgOk:
          'Os convites foram cancelados com sucesso para os clientes selecionados!',
      },
      cancelInvites: {
        title: 'Cancelar convites',
        description1: 'Tem certeza que deseja cancelar os convites para',
        description2: 'cliente(s)?',
        yesLabel: 'Sim',
        noLabel: 'Não',
        cancelMsgOk:
          'Os convites foram cancelados com sucesso para os clientes selecionados!',
      },
      export: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
        errorTitle: 'Oops...',
      },
    },
  },
  reminders: {
    pageTitle: 'Lembretes',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    selectPage: 'Selecionar página',
    channelFilter: {
      select: 'Todos os canais',
      email: 'E-mail',
      sms: 'SMS',
      all: 'E-mail e SMS',
    },
    selectInfo: {
      remindersLength:
        'Você selecionou {length} lembrete(s) para cancelamento.',
      selectAll: 'Selecionar todos os {length}.',
      allReminders:
        'Você selecionou todos os {length} lembrete(s) para cancelamento.',
      cleanSelection: 'Limpar seleção.',
    },
    remindersTable: {
      labels: {
        id: 'ID',
        action: 'Ação',
        client: 'Cliente',
        date: 'Data do lembrete',
        channel: 'Canal',
        cancel: 'Cancelar lembretes',
      },
    },
    cancelRemindersButton: 'Cancelar lembretes',
    updateList: 'Atualizar Lista',
    messages: {
      sendNoReminder: {
        title: 'Oops...',
        description: 'Você deve selecionar ao menos um lembrete para exclusão.',
      },
      send: {
        title: 'Cancelar lembretes',
        description:
          'Tem certeza que deseja cancelar os lembretes selecionados?',
      },
      sendError: {
        title: 'Erro',
        description: 'Houve algum erro',
      },
      download: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
      },
      downloadError: {
        title: 'Oops! Algo deu errado...',
      },
    },
  },
  scheduling: {
    pageTitle: 'Agendamentos',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    selectPage: 'Selecionar página',
    channelFilter: {
      select: 'Todos os canais',
      email: 'E-mail',
      sms: 'SMS',
      all: 'E-mail e SMS',
    },
    selectInfo: {
      schedulingLength:
        'Você selecionou {length} agendamento(s) para cancelamento.',
      selectAll: 'Selecionar todos os {length}.',
      allSchedulings:
        'Você selecionou todos os {length} agendamento(s) para cancelamento.',
      cleanSelection: 'Limpar seleção.',
    },
    schedulingTable: {
      labels: {
        id: 'ID',
        action: 'Ação',
        client: 'Cliente',
        date: 'Data do agendamento',
        channel: 'Canal',
        cancel: 'Cancelar agendamentos',
      },
    },
    messages: {
      cancelNoSelect: {
        title: 'Oops...',
        description:
          'Você deve selecionar ao menos um agendamento para exclusão.',
      },
      cancelQuestion: {
        title: 'Cancelar agendamentos',
        description:
          'Tem certeza que deseja cancelar os agendamentos selecionados?',
      },
      cancelError: {
        title: 'Erro',
        description: 'Houve algum erro',
      },
      download: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
      },
      maxDownloadError: {
        title: 'Limite de registros!',
        description:
          'Alto volume de registros para Download. Por favor, entre em contato com o suporte IndeCX para essa operação',
      },
      downloadError: {
        title: 'Oops! Algo deu errado...',
      },
    },
    cancelRemindersButton: 'Cancelar agendamentos',
  },
  trash: {
    actionsMenu: {
      title: 'Ações',
      actionsTable: {
        labels: {
          action: 'Ação',
          date: 'Data de exclusão',
          user: 'Usuário',
          restore: 'Restaurar',
        },
      },
    },
    answersMenu: {
      title: 'Respostas',
      searchInput: 'Faça uma busca...',
      searchButton: 'Limpar',
      answersInfo: 'Informações da resposta',
      answersRestore: 'Restaurar resposta',
      exportXLS: 'Exportar para XLS',
      swExport: {
        title: 'Sucesso!',
        description:
          'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
      },
      swError: {
        title: 'Oops',
      },
      swQuestion: {
        title: 'Tem certeza?',
      },
      swAction: {
        description: 'Deseja realmente restaurar essa ação?',
      },
      swAnswer: {
        description: 'Deseja realmente restaurar essa resposta?',
      },
      swRestore: {
        description: 'A ação foi restaurada',
      },
      answersTable: {
        labels: {
          action: 'Ação',
          id: 'ID da pesquisa',
          date: 'Data de exclusão',
          user: 'Usuário',
          client: 'Cliente',
          email: 'E-mail',
          phone: 'Telefone',
          feedback: 'Feedback',
          reason: 'Motivo da exclusão',
          options: 'Opções',
        },
      },
    },
  },
  treatments: {
    pageTitle: 'Tratativas individuais',
    pageSubTitle:
      'Neste módulo você pode tratar individualmente cada cliente de forma dinâmica.',
    filterRullers: 'Ordem da tratativa com base na regra:',
    scheduleClient: 'Cliente agendado: ',
    modifyComment: 'Modificar Comentário',
    registerCategory: 'Registre uma categoria',
    here: 'aqui.',
    searchDropdown: 'Search',
    product: 'Produto',
    attendance: 'Atendimento',
    term: 'Prazo',
    delivery: 'Entrega',
    responseInformation: 'Informações da resposta de',
    close: 'Fechar',
    note: 'Nota',
    channel: 'Canal',
    email: 'E-mail',
    phone: 'Telefone',
    none: 'Nenhum',
    date: 'Data',
    comment: 'Comentário',
    additionalQuestions: 'Perguntas Adicionais',
    anonymous: 'Anônimo',
    noName: 'Sem Nome',
    promoters: 'promoters',
    neutral: 'neutral',
    detractors: 'detractors',
    invalid: 'invalid',
    system: 'Sistema',
    alertEmail: 'E-mail de alerta enviado para {itemChange}.',
    statusUpdate: 'Status alterado para {itemChange}.',
    answerCategory: 'Resposta categorizada como {itemChange}.',
    removedCategory: 'Categoria {itemChange} removida para a resposta.',
    newComment: 'Novo comentário adicionado para a resposta: {itemChange}',
    responsibleDealt: 'Responsável pela tratativa alterado para {itemChange}.',
    responseCollected:
      'Essa resposta foi coletada manualmente por {itemChange}',
    resurveySubmitted: 'Repesquisa disparada com sucesso!',
    removedAnswer: 'Resposta removida',
    restoredAnswer: 'Resposta restaurada',
    resurveyScheduled: 'Reepesquisa agendada com sucesso.',
    transfer: 'Resposta transferida para Filial - Mercedes Benz',
    options: 'Opções',
    userReplyTratativa: 'Usuário respondeu a tratativa',
    unreadTratativa: 'Tem resposta não lida',
    messages: {
      updateComment: {
        title: 'Comentário Alterado!',
        description: 'Seu comentário foi alterado',
      },
      errorUpdateComment: {
        title: 'Oops! Algo deu errado!',
        description: 'Tente novamente mais tarde!',
      },
    },
    indicators: 'Indicadores',
    overview: {
      total: 'Total',
      answered: 'Respondidas',
      opened: 'Abertas',
      staggered: 'Escalonadas',
      analysis: 'Em análise',
      others: 'Outros',
    },
    statusSelect: {
      select: 'Filtro por status',
      all: 'Todos',
      answered: 'Respondido',
      analysis: 'Em análise',
      staggered: 'Escalonada',
      opened: 'Aberto',
      others: 'Outros',
    },
    treatmentTable: {
      labels: {
        id: 'ID',
        date: 'Data',
        grade: 'Nota',
        client: 'Cliente',
        comment: 'Comentário',
        responsible: 'Responsável',
        category: 'Categorias',
        status: 'Status',
        days: 'Duração',
        options: 'Opções',
      },
      dropdown: {
        options: {
          answered: 'Respondido',
          analysis: 'Em análise',
          staggered: 'Escalonada',
          opened: 'Aberto',
          others: 'Outros',
        },
        status: {
          aberto: 'Aberto',
          respondido: 'Respondido',
          em_analise: 'Em análise',
          escalonada: 'Escalonada',
          expirado: 'Expirado',
          resp_fora_prazo: 'Resp. fora do prazo',
        },
      },
    },
    resurveyWarning: {
      title: 'Há uma repesquisa configurada!',
      description:
        'Essa ação irá gerar um novo disparo "Repesquisa" automaticamente para esse cliente e não será possível alterar o status novamente. Deseja alterar o status para respondido e disparar a repesquisa?',
      cancelButton: 'Cancelar',
      saveButton: 'Alterar status',
    },
  },
  closetheloop: {
    steps: {
      selectAnswers: 'Selecionar respostas',
      configTemplate: 'Configurar template',
      reviewSubmission: 'Revisar envio',
    },
    selectAnswers: {
      answersLength:
        'Você selecionou {length} resposta(s) para o fechamento do loop.',
      selectAll: 'Selecionar todas',
      allSelected:
        'Você selecionou {totalAnswers} respostas para o fechamento do loop.',
      cleanSelection: 'Limpar seleção',
      validationText: 'Selecione ao menos uma resposta',
      selectLabel: 'Selecionar',
      closureType: 'Qual tipo de fechamento você gostaria de fazer?',
      byEmail: 'Por email',
      onlyStatus: 'Apenas status de tratativa',
      swal: {
        noReply: {
          title: 'Oops...',
          description: 'Selecione pelo menos uma resposta!',
        },
        confirmAction: {
          title: 'Tratativa em massa - Status',
          description: 'Deseja realmente realizar a tratativa em massa?',
        },
        success: {
          title: 'Sucesso',
          description: 'Fechamento em massa realizado com sucesso!',
        },
        selectStatus: {
          title: 'Oops..',
          description: 'Selecione um status!',
        },
      },
    },
    configureTemplate: {
      emailSubject: 'Assunto',
      emailSubjectPlaceholder: 'Informe o assunto do e-mail',
      emailSender: 'Remetente',
      emailSenderPlaceholder: 'Informe o nome do remetente',
      templateDescription:
        'Configure e salve seus templates para que seja possível utilizá-los novamente de forma rápida e prática.',
      myTemplatesTitle: 'Meus templates',
      myTemplatesDescription:
        'Selecione um template abaixo para visualizar a formatação do e-mail e faça alterações caso necessário.',
      selectTemplate: 'Selecione um template',
      saveTemplate: 'Salvar templates',
      saveTemplatePlaceholder: 'Digite o nome do template',
      saveButton: 'Salvar',
      templatedCreatedTitle: 'Sucesso!',
      templatedCreatedDescription: 'O novo template foi criado com sucesso!',
      statusTitle: 'Status do close the loop',
      statusDescription:
        'Selecione abaixo qual será o status padrão das respostas após o envio do e-mail.',
      responsibleTitle: 'Responsável',
      responsibleDescription:
        'Após o disparo realizado, o usuário será atribuído automaticamente como responsável por essas tratativas.',
      errorDescription: 'Informe o assunto do e-mail e o remetente.',
      saveErrorDescription:
        'Informe o nome do template, o assunto do e-mail e o remetente.',
    },
    reviewSubmission: {
      description:
        'Revise os dados abaixo antes do envio e certifique-se que os filtros aplicados estão corretos. Após o disparo do e-mail, não é possível cancelar o processo.',
      answersTotal: 'Total de clientes impactados',
      appliedFilters: 'Filtros aplicados',
      action: 'Ação',
      metric: 'Métrica',
      startDate: 'Data início',
      endDate: 'Data fim',
      allPeriod: 'Todo período',
      search: 'Busca',
      ih1: 'Filial',
      ih2: 'IH2',
      profile: 'Perfil',
      indicator: 'Indicador',
      configTemplate: 'Template configurado',
      sendStatus: 'Status por envio',
      responsible: 'Responsável',
      category: 'Categoria',
      comment: 'Comentário',
      anonymous: 'Anônimo',
      subCategory: 'Subcategoria',
      submitTitle: 'Sucesso!',
      submitDescription:
        'O disparo do close the loop está sendo feito e em breve os clientes selecionados receberão o e-mail.',
    },
    nextButon: 'Próximo',
    goBackButton: 'Voltar',
    sendButton: 'Enviar',
  },
  reports: {
    npsPonder: {
      reportTitle: 'NPS Ponderado',
      action: 'Açao',
      groupAction: 'Grupo de ação',
      channel: 'Canal',
      weight: 'Peso',
      answers: 'Respostas',
      promoters: 'Promotores',
      passive: 'Neutros',
      detractors: 'Detratores',
    },
    hts: {
      reportTitle: 'Relatório HTS',
    },
    selectReport: 'Selecione um relatório',
    emptyMsg: 'Selecione na lista uma visão de relatório',
    pageTitle: 'Relatórios',
    subTitle: 'Relatório',
    searchInput: 'Faça uma busca...',
    searchButton: 'Limpar',
    selectProfile: 'Selecione um perfil',
    answersLabel: 'Respostas',
    inviteLabel: 'Convites',
    promoterLabel: 'Promotores',
    neutralLabel: 'Neutros',
    detractorLabel: 'Detratores',
    noteDetractorCesLabel: 'Notas 1 e 2',
    noteNeutralCesLabel: 'Nota 3',
    notePromoterCesLabel: 'Notas 4 e 5',
    monthlyLabel: 'Mensal',
    dailyLabel: 'Diário',
    weeklyLabel: 'Semanal',
    quarterlyLabel: 'Trimestral',
    accLabel: 'Acumulado',
    accMonthlyLabel: 'Mensal Acumulado',
    accDailyLabel: 'Diário Acumulado',
    accWeeklyLabel: 'Semanal Acumulado',
    accQuarterlyLabel: 'Trimestral Acumulado',
    downloadLabel: 'Download',
    sucessLabel: 'Sucesso',
    errorLabel: 'Oops',
    cancelLabel: 'Cancelar',
    dontHaveData: 'Você ainda não possui dados para serem exibidos aqui.',
    downloadMsg:
      'O arquivo está sendo preparado! Você pode acompanhar o status de processamento no menu Arquivos >> Downloads.',
    npsLabel: 'NPS',
    cesLabel: 'CES',
    csatLabel: 'CSAT',
    csatAverageLabel: 'CSAT (Média)',
    fiveStarsLabel: '5-Stars',
    likeDislikeLabel: 'Like/Dislike',
    loadingLabel: 'Carregando',
    noteCloudPromoter: 'Notas 4 e 5',
    noteCloudNeutral: 'Nota 3',
    noteCloudDetractor: 'Notas 1 e 2',
    exportXlsLabel: 'Exportar tabela para XLS',
    bounceEmail: 'Possíveis erros de e-mail',
    invalidAccount: 'Conta inválida',
    invalidDomain: 'Domínio inválido',
    mailBoxFull: 'Caixa postal cheia',
    antiSpamBlocking: 'Bloqueio anti-spam',
    accountUnavailable: 'Conta indisponível',
    unavailableServer: 'Servidor indisponível',
    deliveryFailure: 'Falha na entrega',
    reportImpactReminder: 'Impacto dos lembretes na conversão',
    cardPercentageWithReminder: '% RESPOSTAS COM LEMBRETES',
    cardPercentageOfNoReminder: '% RESPOSTAS SEM LEMBRETES',
    quantityInvites: 'Quantidade de convites',
    answeredInvites: 'Convites respondidos',
    unansweredInvitations: 'Convites nao respondidos',
    conversionPercentage: 'Percentual de conversão',
    reminderName: 'Lembrete',
    // when translating, please keep "key" contents, translate only "value" contents
    fullMonthNames: [
      {
        key: 'janeiro',
        value: 'janeiro',
      },
      {
        key: 'fevereiro',
        value: 'fevereiro',
      },
      {
        key: 'março',
        value: 'março',
      },
      {
        key: 'abril',
        value: 'abril',
      },
      {
        key: 'maio',
        value: 'maio',
      },
      {
        key: 'junho',
        value: 'junho',
      },
      {
        key: 'julho',
        value: 'julho',
      },
      {
        key: 'agosto',
        value: 'agosto',
      },
      {
        key: 'setembro',
        value: 'setembro',
      },
      {
        key: 'outubro',
        value: 'outubro',
      },
      {
        key: 'novembro',
        value: 'novembro',
      },
      {
        key: 'dezembro',
        value: 'dezembro',
      },
    ],
    // when translating, please keep "key" contents, translate only "value" contents
    reportTitles: [
      {
        key: 'Evolução de NPS',
        value: 'Evolução de NPS',
        cesValue: 'Evolução de CES',
        csatValue: 'Evolução de CSAT',
        csatValueAverage: 'Evolução de CSAT (Média)',
        fiveStarsValue: 'Evolução 5Stars',
        likeDislikeValue: 'Evolução Like/Dislike',
      },
      {
        key: 'Evolução de Respostas',
        value: 'Evolução de Respostas',
      },
      {
        key: 'Evolução de Percentuais',
        value: 'Evolução de Percentuais',
      },
      {
        key: 'Rankings',
        value: 'Rankings',
      },
      {
        key: 'Comparativo de Ações',
        value: 'Comparativo de Ações',
      },
      {
        key: 'Comparativo de Categorias',
        value: 'Comparativo de Categorias',
      },
      {
        key: 'Categorias',
        value: 'Categorias',
      },
      {
        key: 'Nuvem de Palavras',
        value: 'Nuvem de Palavras',
      },
      {
        key: 'NPS por Indicadores',
        value: 'NPS por Indicadores',
        cesValue: 'CES por Indicadores',
        csatValue: 'CSAT por Indicadores',
        csatValueAverage: 'CSAT (Média) por Indicadores',
        fiveStarsValue: '5Stars por Indicadores',
        likeDislikeValue: 'Like/Dislike por Indicadores',
      },
      {
        key: 'Relatório de Mapa - NPS',
        value: 'Relatório de Mapa - NPS',
        cesValue: 'Relatório de Mapa - CES',
        csatValue: 'Relatório de Mapa - CSAT',
        csatValueAverage: 'Relatório de Mapa - CSAT (Média)',
        fiveStarsValue: 'Relatório de Mapa - 5Stars',
        likeDislikeValue: 'Relatório de Mapa - Like/Dislike',
      },
      {
        key: 'Evolução de Perguntas Adicionais',
        value: 'Evolução de Perguntas Adicionais',
      },
      {
        key: 'Comparativo Indicadores',
        value: 'Comparativo Indicadores',
      },
      {
        key: 'Detratores Recorrentes',
        value: 'Detratores Recorrentes',
      },
      {
        key: 'Quadro Resumo',
        value: 'Quadro Resumo',
      },
      {
        key: 'Comparativo Regional e Nacional',
        value: 'Comparativo Regional e Nacional',
      },
      {
        key: 'Status dos Disparos',
        value: 'Status dos Disparos',
      },
      {
        key: 'Status de Tratativas',
        value: 'Status de Tratativas',
      },
      {
        key: 'Relatório CXI',
        value: 'CXI – Pós Vendas',
      },
      {
        key: 'Relatório CXI',
        value: 'Relatório CXI - Vendas',
      },
      {
        key: 'Relatório CXI Vendas - Caminhoes',
        value: 'Relatório CXI Vendas - Caminhoes',
      },
      {
        key: 'Relatório CXI Vendas - Vans',
        value: 'Relatório CXI Vendas - Vans',
      },
      {
        key: 'Relatório Auditoria',
        value: 'Relatório Auditoria',
      },
      {
        key: 'Relatório Comparativo de N1 e N2',
        value: 'Relatório Comparativo de N1 e N2',
      },
      {
        key: 'Relatório Impacto dos Lembretes',
        value: 'Relatório Impacto dos Lembretes',
      },
      {
        key: 'Status de Tratativas',
        value: 'Status de Tratativas',
      },
      {
        key: 'Evolução de Categorias',
        value: 'Evolução de Categorias',
      },
      {
        key: 'Evolução de Convites',
        value: 'Evolução de Convites',
      },
      {
        key: 'Tags de Tratativas',
        value: 'Tags de Tratativas',
      },
    ],
    basicColumn: {
      reportTitle: 'Evolução de NPS',
      csatReportTitle: 'Evolução de CSAT',
      cesReportTitle: 'Evolução de CES',
      csatAverageReportTitle: 'Evolução de CSAT(Média)',
      fiveStarsReportTitle: '5 Stars',
      csatValue: 'CSAT por Indicadores',
      csatValueAverage: 'CSAT(Média) por Indicadores',
      fiveStarsValue: '5Stars por Indicadores',
      likeDislikeReportTitle: 'Like/Dislike',
    },
    answerEvolution: {
      reportTitle: 'Evolução de Respostas',
    },
    invitesEvolution: {
      reportTitle: 'Evolução de Convites',
    },
    percentageEvolution: {
      reportTitle: 'Evolução de Percentuais',
    },
    tags: {
      reportTitle: 'Relatório de Tags',
      allTags: 'Todas as Tags',
      subtags: 'Subtags',
      totalClassified: 'Total de tratativas classificadas',
    },
    categories: {
      reportTitle: 'Relatório de Categorias',
      allCategories: 'Todas as Categorias',
      scorelabel: 'Score',
      totalLabel: 'Total',
      totalCategorized: 'Total de Respostas Categorizadas',
      promoterCategorized: 'Total de Respostas Promotoras Categorizadas',
      neutralCategorized: 'Total de Respostas Neutras Categorizadas',
      detractorCategorized: 'Total de Respostas Detratoras Categorizadas',
      notes4and5: 'Nota 4 e 5',
      note3: 'Nota 3',
      notes1and3: 'Nota 1 e 3',
      subcategories: 'Subcategorias',
      optionText:
        'Categoria (base frequência) - Cálculo: Categoria/Total de categorias.\n' +
        'Categoria (base respostas) - Cálculo: Categoria/Total de respostas.',
      frequencyOption: 'Categoria (Base frequência)',
      normalOption: 'Categoria (Base respostas)',
      totalCategories: 'Total de Categorias',
    },
    multipleSubOptions: {
      multipleSubOptions: 'Multipla com sub opções',
      optionFrequency: 'Opção (Base frequência)',
      optionAnswer: 'Opção (Base resposta)',
    },
    conversionDetails: {
      reportTitle: 'Relatório de Conversão / Detalhamento Importação',
      searchAction: 'Buscar ação',
    },
    categoriesEvolution: {
      reportTitle: 'Relatório de Evolução de Categorias',
      optionText:
        'Categoria (base frequência) - Cálculo: Categoria/Total de categorias.\n' +
        'Categoria (base respostas) - Cálculo: Categoria/Total de respostas.',
      frequencyOption: 'Categoria (Base frequência)',
      normalOption: 'Categoria (Base respostas)',
      profileLabel: 'Perfil',
      selProfileLabel: 'Selecione perfil',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
      categoryLabel: 'Categoria',
      selCategoryLabel: 'Selecione categoria',
    },
    categoriesTags: {
      categories: 'Entrada: Categorias',
      subCategories: 'Entrada: Sub Categorias',
      tags: 'Saida: Tags de Tratativas',
      loadAllCategories: 'Carregar todas as Categorias',
      profileLabel: 'Perfil',
      selProfileLabel: 'Selecione perfil',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
    },
    indicators: {
      reportTitle: 'Relatório de Indicadores',
      byIndicators: 'por indicadores',
      indicatorLabel: 'Indicador',
      descriptionLabel: 'Descrição',
      selIndicatorLabel:
        'Por favor, selecione algum indicador para exibir os dados.',
      noDatalabel: 'Nenhum dado a ser exibido',
      noAnswerLabel:
        'Nenhuma resposta associada a esse indicador foi encontrada.',
      selIndicatorSelectLabel: 'Selecione um indicador',
      answerDownloadlabel: 'Download das respostas',
    },
    comparativeIndicators: {
      reportTitle: 'Comparativo de Indicadores',
      valueLabel: 'Valor',
      fillFieldsMsg:
        'Por favor, preencha os campos acima para exibir o relatório.',
      selIndicatorLabel: 'Selecione um indicador',
      selValueLabel: 'Selecione um valor',
    },
    comparativeN1N2: {
      title: 'Comparativo de N1 e N2 - Análise de Porcentagem',
      yAxisLabel: 'N1 N2',
    },
    comparativeCategories: {
      categoryLabel: 'Categoria',
      reportTitle: 'Comparativo de Categorias - Análise de Porcentagem',
      reportTitleMultiple: 'Comparativo de Opções - Análise de Porcentagem',
      fillFieldsMsg:
        'Por favor, preencha os campos acima para exibir o relatório.',
      selCategoryLabel: 'Selecione categoria',
      profileLabel: 'Perfil',
      selProfileLabel: 'Selecione perfil',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
      subcategoryLabel: 'Subcategoria',
      selSubcategoryLabel: 'Selecione subcategoria',
      analyzeLabel: 'Analisar',
      allLabel: 'Todos',
      yAxisLabel: 'Categorizado',
    },
    detractor: {
      reportTitle: 'Detratores Recorrentes',
      loadingLabel: 'Loading',
      noDataLabel: 'Nenhum dado a ser exibido',
      noDataMsg: 'Nenhum dado foi encontrado para os filtros selecionados.',
      answerDetailsLabel: 'Detalhes da resposta',
      seriesNameLabel: 'Quantidade de detratores recorrentes',
      tableCustomerLabel: 'Cliente',
      tableDateLabel: 'Data',
      tableReviewLabel: 'Nota',
      tablePreviousDateLabel: 'Data da nota anterior',
      tablePreviousReviewLabel: 'Nota',
      tableDetailsLabel: 'Detalhes',
    },
    evolAddQuestion: {
      reportTitle: 'Relatório de Perguntas Adicionais',
      additionalQuestionlabel: 'Pergunta Adicional',
      loadingLabel: 'Loading',
      selSelectAddQuestionLabel: 'Selecione uma Pergunta Adicional',
      selAddQuestionLabel:
        'Por favor, selecione alguma Pergunta Adicional para exibir os dados.',
      graphTitle: 'Evolução de Pergunta Adicional',
      title: 'Evolução de Perguntas Adicionais',
    },
    groupNps: {
      reportTitle: 'Relatório Comparativo Regional e Nacional',
      selIh1Label:
        'Por favor, selecione alguma Concessionária na opção de filtros.',
      generalTitleLabel: 'Nacional',
    },
    horizontalBar: {
      chartTitle: 'NPS - Percentual',
      cesChartTitle: 'CES - Percentual',
      csatChartTitle: 'CSAT - Percentual',
      csatAverageChartTitle: 'CSAT(Média) - Percentual',
      csat0to10AverageChartTitle: 'CSAT(0 a 10) - Percentual',
      csatPromoters: '9 e 10',
      csatPassives: '7 e 8',
      chartSeries: 'Percentual',
      ceschartSeries: 'Quantidade',
      chartNoData: 'NPS - Percentual (sem dados para exibir)',
      cesChartNoData: 'CES - Percentual (sem dados para exibir)',
      csatChartNoData: 'CSAT - Percentual (sem dados para exibir)',
      csatchartSeries: 'Quantidade',
      fiveStarsTitle: '5-Stars Percentual',
      fiveStarsNoData: '5 Stars - Percentual (sem dados para exibir)',
      fiveStarschartSeries: 'Quantidade',
      likeDislikeTitle: 'Like/Dislike Percentual',
      likeDislikeNoData: 'Like/Dislike - Percentual (sem dados para exibir)',
      likeDislikechartSeries: 'Quantidade',
    },
    inviteStatus: {
      reportTitle: 'Status de Disparos',
      noDataLabel: 'Nenhum dado a ser exibido',
      noDataMsg: 'Nenhum dado foi encontrado para os filtros selecionados.',
      seeDetailsLabel: 'Ver detalhes',
      emailLabel: 'E-mail',
      smsLabel: 'SMS',
      invitesLabel: 'Disparos',
      deliveredLabel: 'Entregues',
      openedLabel: 'Abertos',
      clickedLabel: 'Clicados',
      bounceLabel: 'Erro',
      spamLabel: 'Spam Reports',
      notDeliveredLabel: 'Não Entregues',
      phoneLabel: 'Telefone',
      detailDeliveredLabel: 'Detalhes dos convites entregues',
      detailOpenedLabel: 'Detalhes dos convites abertos',
      detailClickedLabel: 'Detalhes dos convites clicados',
      detailSpamLabel: 'Detalhes dos convites colocados em spam',
      detailBounceLabel: 'Detalhes dos convites em bounce',
      detailNotReceivedLabel: 'Detalhes dos convites não recebidos',
      detailDefaultLabel: 'Detalhes dos convites',
      deliveryPercentLabel: 'Percentual de entrega',
      customerLabel: 'Cliente',
      inviteIdLabel: 'ID do convite',
      sentDateLabel: 'Data de envio',
      invitesLabelInfoEmail:
        'Quantidade de disparos realizados para o e-mail do cliente via API da IndeCX.',
      deliveredLabelInfoEmail:
        'Quantidade de envios bem-sucedidos gerado pelo servidor de mail do destinatário.',
      openedLabelInfo: 'Quantidade de e-mails abertos pelo destinatário.',
      clickedLabelInfo:
        'Quantidade de vezes que o destinatário clicou no link para responder a pesquisa dentro do seu e-mail.',
      bounceLabelInfo:
        'Quantidade de vezes em que o servidor não pode receber ou aceitou a mensagem.',
      spamLabelInfo:
        'Quantidade de vezes que o destinatário marcou o e-mail como spam.',
      invitesLabelInfoSMS:
        'Quantidade de disparos realizados para o número do cliente via API da IndeCX.',
      deliveredLabelInfoSMS:
        'Quantidade de envios bem sucedidos gerado pelo servidor de SMS do destinatário.',
      notDeliveredLabelInfo:
        'Quantidade de SMS que não foram entregues ao destinatário.',
    },
    mapChart: {
      brasil: 'Brasil',
      mapMundi: 'Mapa mundi',
      reportTitle: 'Relatório de Mapa - {metric}',
      subtitleLabel: 'Legenda',
      npslt0: 'NPS menor que 0',
      npslt50: 'NPS de 0 a 49',
      npslt70: 'NPS de 50 a 69',
      npslt80: 'NPS de 70 a 79',
      npsge80: 'NPS de 80 a 100',
      ceslt2: 'CES menor que 2',
      ceslt3: 'CES de 2 a 3',
      ceslt4: 'CES de 3 a 4',
      ceslt5: 'CES de 4 a 5',
      cesge5: 'CES 5',
      fiveStarslt2: '5-Stars menor que 2',
      fiveStarslt3: '5-Stars de 2 a 3',
      fiveStarslt4: '5-Stars de 3 a 4',
      fiveStarslt5: '5-Stars de 4 a 5',
      fiveStarsge5: '5-Stars 5',
      ufLabel: 'UF',
      localeLabel: 'País',
    },
    treatmentMonitoring: {
      treatment: 'Tratativas',
      averageTreatment: 'Média de tratativas realizadas',
      averageTreatmentDesc:
        'Média de tratativas com Status Respondido no período selecionado',
      totalPeriod: 'Total no período',
      startAverage: 'Tempo médio p/ Início Tratativa',
      startAverageDesc:
        'Tempo entre o registro da primeira tratativa e a data da resposta.',
      hours: 'horas',
      averageAnswer: 'Tempo médio de resposta',
      averageAnswerDesc:
        ' Tempo médio entre a finalização da tratativa com Status Respondido e a data de resposta.',
      averageNoStart: 'Tempo médio sem tratativa iniciada',
      averageNoStartDesc:
        'Tempo entre a data atual e a data da resposta da tratativa.',
      averagePending: 'Tempo médio de tratativas pendentes',
      averagePendingDesc:
        'Tempo entre a data atual e a data do inicio da primeira tratativa no período selecionado',
      operatorStatus: 'Status do operador',
      currentStatus: 'Status atual',
      treatmentCard: 'Tratativa',
      averagePeriod: 'Média de tratativas no período',
      massTreatment: ' Tratativas em massa no período',
      profile: 'Perfil',
    },
    monthlyDetractors: {
      reportTitle: 'Detratores Mensais',
      noDataLabel: 'Detratores Mensais - Nenhum dado a ser exibido',
      noDataMsg: 'Nenhum dado foi encontrado para os filtros selecionados.',
      chartTitle: 'Detratores Mensais',
      chartSeries: 'Quantidade de detratores',
    },
    csat: {
      csatLabelReport: 'Escala 0 a 10',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    nps: {
      npsLabelReport: 'NPS',
      addQuestionLabel: 'Pergunta adicional',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    ces: {
      cesLabelReport: 'Escala Ces 1 a 5',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    emotion: {
      emotionLabel: 'Emotion',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    likeDislike: {
      likeDislikeLabel: 'Like Dislike',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    likeDislikeGroup: {
      likeDislikeLabel: 'Like Dislike',
      addQuestionLabel: 'Pergunta adicional',
      branchLabel: 'Filial',
      groupLabel: 'Regional',
      companyLabel: 'Nacional',
    },
    likert: {
      likertLabel: 'LIKERT',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    reviews: {
      reviewsLabel: 'REVIEWS',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    reviewsGroup: {
      reviewsLabel: 'REVIEWS',
      addQuestionLabel: 'Pergunta adicional',
      branchLabel: 'Filial',
      groupLabel: 'Regional',
      companyLabel: 'Nacional',
    },
    summaryBoard: {
      reportTitle: 'Quadro Resumo - Gerencial',
      invitesLabel: 'Convites',
      answersLabel: 'Respostas',
      conversionLabel: 'Conversão',
      receivedEmails: 'E-mails Recebidos',
      receivedPhones: 'Celulares Recebidos',
      channelQtLabel: 'Quantidade por canal de coleta',
      emailLabel: 'Email',
      smsLabel: 'SMS',
      manualLabel: 'Manual',
      othersLabel: 'Outros',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
      top5detractors: 'Top 5 Categorias - Detratores',
      top5promoters: 'Top 5 Categorias - Promotores ',
      top5passives: 'Top 5 Categorias - Neutros',
      categorizedLabel: '% das ocorrências foram categorizadas',
      positionMsg1: 'Sua posição é',
      positionMsg2: 'no ranking nacional no período selecionado',
    },
    npsBar: {
      reportTitle: 'NPS - Net Promoter Score',
      cesReportTitle: 'CES - Customer Effort Score',
      likeDislikeReportTitle: 'Like/Dislike',
      csatReportTitle: 'CSAT - Customer Satisfaction Score',
      csatAverageReportTitle: 'CSAT(Média) - Customer Satisfaction Score',
      csat0to10ReportTitle: 'CSAT(0 a 10) - Customer Satisfaction Score',
      csat0to10AverageReportTitle: 'CSAT(0 a 10) - Customer Satisfaction Score',
      fiveStarsReportTitle: '5-Stars',
      npsMessage: 'Seu nps é de',
      cesMessage: 'Seu ces é de',
      csatMessage: 'Seu csat é de',
      fiveStarsMessage: 'Seu 5 Stars é de',
      likeDislikeMessage: 'Seu like/dislike é de',
      noDataMsg: 'Sem dados para exibir',
      noData: 'Sem dados no período',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
    },
    treatmentStatus: {
      noDataLabel: 'Nenhum dado a ser exibido',
      noDataMsg: 'Nenhum dado foi encontrado para os filtros selecionados.',
      allSelected: 'Todos os perfis',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detrator',
      answers: 'Respostas',
      answeredLabel: 'Respondido',
      openedLabel: 'Aberto',
      analysedLabel: 'Em análise',
      others: 'Outros',
      staggeredLabel: 'Escalonado',
      chartTitle: 'Status de tratativas mensal',
    },
    verticalColumn: {
      chartTitle: 'NPS - Notas',
      cesChartTitle: 'CES - Notas',
      csatChartTitle: 'CSAT - Notas',
      csatAverageChartTitle: 'CSAT(Média) - Notas',
      csat0to10AverageChartTitle: 'CSAT(0 a 10) - Notas',
      fiveStarsChartTitle: '5-Stars Notas',
      chartSeries: 'Quantidade',
      likeDislikeReportTitle: 'Like/Dislike - Notas',
    },
    wordCloud: {
      anonimousLabel: 'Anônimo',
      noDataMessage: 'Nenhuma palavra selecionada.',
      commentLabel: 'Comentário',
      dateLabel: 'Data',
      gradeLabel: 'Nota',
      customerLabel: 'Cliente',
      detailsLabel: 'Detalhes',
    },
    cxiReport: {
      reportTitle: 'Indicador CXI de Pós-vendas',
      cxiLabel: 'CXI',
      noDataMsg: 'Sem dados para exibir',
      reportHeader1: 'Relatório CXI de Pós-vendas',
      reportHeader2:
        'O indicador CXI é composto por 3 indicadores: Satisfação Geral (50%), Recomendação (25%) e Revisita (25%)',
      questionHeader: 'Pergunta',
      score: 'Score',
      index: 'Índice consolidado',
      satisfaction: 'Satisfação',
      indexByMonth: 'Índice por mes',
    },
    cxiReport2024: {
      reportTitle: 'Indicador CXI de Pós-vendas',
      cxiLabel: 'Indicador por mês',
      noDataMsg: 'Sem dados para exibir',
      reportHeader1: 'Relatório CXI de Pós-vendas',
      reportHeader2:
        ' O Indicador Final é composto da seguinte forma: (Média do Item A * 30%) + (Média do Item B*70%).',
      reportHeader3:
        'A nota é baseada na soma de todas as pesquisas respondidas de acordo com o período filtrado.',
      questionHeader: 'Pergunta',
      score: 'Score',
      graphicTitle: 'Indicador final - 360',
      indexByMonth: 'Índice por mes',
      questionA: 'Perguntas - Itens A (Perguntas adicionais)',
      questionB: 'Perguntas - Itens B (CXI)',
    },
    cxiSalesReport: {
      reportTitle: 'Indicador CXI de Vendas',
      cxiLabel: 'CXI',
      noDataMsg: 'Sem dados para exibir',
      reportHeader1: 'Relatório CXI de Vendas',
      reportHeader2:
        'O indicador CXI é composto por 3 indicadores: Satisfação Geral (50%), Recomendação (25%) e Revisita (25%)',
      questionHeader: 'Pergunta',
      score: 'Score',
    },
    ccsi: {
      reportTitle: 'Indicador CCSI',
      ccsiLabel: 'Índice CCSI',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    hgsi: {
      reportTitle: 'Indicador HGSI',
      hgsiLabel: 'Índice HGSI',
      scsiLabel: 'Índice SCSI',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    prehgsi: {
      reportTitle: 'Indicador PRE-HGSI',
      prehgsiLabel: 'Índice PRE-HGSI',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    fcsi: {
      reportTitle: 'Indicador FCSI',
      fcsiLabel: 'Índice FCSI',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    multiples: {
      multiplesLabel: 'Múltipla Escolha',
      addQuestionLabel: 'Pergunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respostas',
    },
    partsAvailability: {
      filterTitle: 'Filtro por subsegmento',
      filterPlaceholder: 'Selecione um subsegmento',
      reportTitle: 'Disponibilidade de peças',
      table: {
        date: 'Data',
        review: 'Nota',
        customer: 'Cliente',
        comment: 'Comentário',
        details: 'Detalhes',
      },
    },
    sentmentAnalysis: {
      reportTitle: 'Análise de sentimento',
      reportDescription:
        'A IndeCX utiliza Inteligência Artificial para classificação do sentimento e extração de palavras-chaves com base nos comentários. O score abaixo indica o nível do sentimento, podendo variar de -100 até 100.',
      total: 'Total',
      percentAnalyzed: 'das respostas foram analisadas.',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
      classificationReportTitle: 'Classificação de sentimento',
      classificationReportTitleMonthly:
        'Classificação de sentimento ao longo do tempo',
      sentmentScoreReportTitle: 'Score de sentimento',
      sentmentScoreReportTitleMonthly: 'Score de sentimento por mês',
      keywordsTablePositive: {
        keywords: 'Keywords Positivas',
        percentage: '%',
        total: 'Total',
      },
      keywordsTableNeutral: {
        keywords: 'Keywords Neutras',
        percentage: '%',
        total: 'Total',
      },
      keywordsTableNegative: {
        keywords: 'Keywords Negativas',
        percentage: '%',
        total: 'Total',
      },
      indicatorTitle: 'Sentimento por indicador',
      selectTitle: 'Indicador:',
      selectPlaceholder: 'Selecione um indicador',
      indicatorTable: {
        indicator: 'Indicador',
        description: 'Descrição',
        score: 'Score',
        total: 'Total',
      },
    },
    deviceAnalysis: {
      deviceTitle: 'Resposta por dispositivo',
      deviceSubText: 'Dispositivo utilizado para resposta da pesquisa',
      qty: 'Quantidade',
      browserTitle: 'Resposta por browser',
      browserSubText: 'Browser utilizado para resposta da pesquisa',
      soTitle: 'Resposta por sistema operacional',
      soSubText: 'Sistema operacional utilizado nos dispositivos',
      selectDevice: 'Selecione o device',
      all: 'Todos',
    },
  },
  aiReports: {
    aiAnalysis: 'Análise IA',
    swotAnalysis: 'Análise SWOT',
    swotAnalysisText:
      'Análise SWOT é uma técnica de planejamento estratégico utilizada para auxiliar pessoas ou organizações a identificar forças, fraquezas, oportunidades, e ameaças relacionadas à competição em negócios ou planejamento de projetos.',
    summarization: 'Sumarização',
    summarizationText:
      'Sumarização é uma técnica de planejamento estratégico utilizada para auxiliar pessoas ou organizações a identificar forças, fraquezas, oportunidades, e ameaças relacionadas à competição em negócios ou planejamento de projetos.',
    selectReport: 'Selecionar Relatório',
    comingSoon: 'Em breve',
    newAnalysis: 'Nova Análise',
    searchInput: 'Pesquisar',
    searchButton: 'Limpar',
    swotTable: {
      labels: {
        id: 'ID',
        filters: 'Filtros para Análise SWOT',
        createdAt: 'Criado em',
        period: 'Período',
        qtd: 'Amostra',
        status: 'Status',
        visualization: 'Visualização',
      },
      status: {
        processando: 'Processando',
        processado: 'Processado',
        falha: 'Falha',
      },
    },
    summarizationTable: {
      labels: {
        id: 'ID',
        filters: 'Filtros para Sumarização',
        createdAt: 'Criado em',
        period: 'Período',
        qtd: 'Amostra',
        status: 'Status',
        visualization: 'Visualização',
      },
      status: {
        processando: 'Processando',
        processado: 'Processado',
        falha: 'Falha',
      },
    },
    newAiReport: {
      analysisFilter: 'Filtro de análise',
      analysisRevision: 'Revisão de análise',
      answersPeriod: 'Período de respostas',
      filters: 'Filtros',
      actionGroup: 'Grupo de Ação',
      action: 'Ação',
      profile: 'Perfil',
      ih1: 'Filial',
      selectedItens: 'Filtros aplicados',
      actions: 'Ações',
      revision: 'Revisão de dados',
      selectedFilters: 'Filtros selecionados',
      cancelButton: 'Cancelar',
      nextButton: 'Avançar',
      analyseButton: 'Analisar',
      goBackButton: 'Voltar',
    },
  },
  genericMessages: {
    save: 'Salvar',
    cancel: 'Cancelar',
    success: {
      title: 'Sucesso!',
      description: 'Suas alterações foram salvas com sucesso!',
    },
    error: {
      title: 'Erro',
      description: 'Houve um erro inesperado. Tente novamente mais tarde!',
    },
    goBack: 'Voltar',
    noDataTitle: 'Nenhum dado a ser exibido',
    noDataDescription:
      'Nenhum dado foi encontrado para os filtros selecionados.',
  },

  informationAboutNpsDash: {
    aboutNps: 'Informações sobre NPS',
    rangeNps: 'FAIXA DO NPS',
    reference: '*Referência INDECX',
    awfulTitle: 'Menor que 0 - NPS Péssimo:',
    awful:
      'As empresas com o valor do NPS nessa zona tem a maioria dos seus clientes detratores.​',
    badTitle: 'De 0 a 49 - NPS Ruim:',
    bad: 'Empresas nessa zona tem, normalmente, quantidades de promotores e detratores altos, mas, a quantidade de neutros também influencia.',
    goodTitle: 'De 50 a 69 - NPS Bom:',
    good: 'Empresas que se preocupam em oferecer um atendimento de excelência. Quantidade de promotores supera a de detratores.​',
    veryGoodTitle: 'De 70 a 79 - NPS Muito bom:',
    veryGood:
      'Empresas que oferecem um atendimento de referência na satisfação de clientes. Pouquíssimos detratores.',
    excellentTitle: 'De 80 a 100 - NPS Excelente:',
    excellent:
      'Poucas empresas estão nessa zona e se tornaram referência no atendimento ao cliente que oferecem.',
  },

  panel: {
    panelDataTime: {
      day: 'Diário',
      week: 'Semanal',
      month: 'Mensal',
      quarter: 'Trimestral',
    },
    titleSideBar: 'Painéis',
    createCard: {
      choosePanel: 'Escolha o tipo do painel',
      configPanel: 'Configuração do painel',
      useTemplate: 'Utilizar template',
      template:
        'Nosso time de profissionais idealizaram um template exclusivo pensando no seu cliente.',
      soon: 'Em breve!',
      createPanel: 'Criar painel',
      create:
        'Crie seu painel customizável e tenha uma visão completa da experiência do seu cliente.',
      createPanelButton: 'Criar painel',
      title: 'Escolha uma opção abaixo',
    },
    createCardSecondStep: {
      panelTitle: 'Título do painel',
      description: 'Descrição',
      accessPermission: 'Perfis que terão acesso',
      createPanel: 'Criar painel customizado',
      cancel: 'Cancelar',
      save: 'Salva',
    },
    createCardPanel: {
      modalTitle: 'Criar Card',
      modal:
        'Crie seu card personalizado para o seu painel digite o nome e escolha as métricas que atendem melhor a sua necessidade',
      cardTitle: 'Titulo do card',
      metric: 'Escolha a métrica:',
      metricDescription: 'selecione a métrica',
      type: ' Escolha o tipo de análise',
      reportName: 'Escolha o relatório a ser exibido',
      timeChoise: 'Escolha o período',
      typeData: {
        sentimentAnalyze: 'Análise de sentimento',
        sentimentAnalyzeReports: {
          sentimentClassification: 'Classificação de sentimento',
          sentimentEvolution: 'Evolução de sentimento',
          sentimentScore: 'Score de sentimento',
          topFiveKey: 'Top 5 Keywords',
        },
        npsAnalytics: 'Análise NPS',
        cesAnalytics: 'Análise CES',
        csatAnalytics: 'Análise CSAT',
        fiveStarsAnalytics: 'Análise 5-stars',
        likeDislike: 'Análise Like e Dislike',
        npsAnalyticsReports: {
          invitationsAnalysis: 'Análise de indicador',
          comparativeIndicators: 'Comparativo de ação',
          gradeDistribution: 'Distribuição de notas',
          invitesEvolution: 'Evolução de convites',
          npsEvolution: 'Evolução de nps',
          percentEvolution: 'Evolução de percentuais',
          indexNps: 'Indice NPS',
          npsPercentage: 'NPS-Percentual',
          mapReport: 'Relatório de mapa',
          recurringDetractors: 'Detratores recorrentes',
        },
        categories: 'Categorias',
        categoriesReports: {
          categories: 'Categorias',
        },
        additionalQuestion: 'Perguntas adicionais',
        additionalQuestionReports: {
          multipleChoice: 'Ranking Múltipla escolha',
          ces1a5: 'Ranking Ces 1 a 5',
          emotion: 'Ranking Emotion',
          scale0a10: 'Ranking Escala 0 a 10',
          likeOrDeslike: 'Ranking Like/dislike',
          likert: 'Ranking Likert',
          nps: 'Ranking NPS',
          review: 'Ranking Review',
        },
        others: 'Outros',
        othersReports: {
          deviceAnalysis: 'Análise por dispositivo',
          conversion: 'Conversão',
          evolutionOfAnswers: 'Evolução de respostas',
          keyCloud: 'Nuvem de palavras',
          replyByChannel: 'Resposta por canais',
          treatmentStatus: 'Status de tratativas',
        },
      },
      chooseTime: {
        today: 'hoje',
        yesterday: 'Ontem',
        last30Days: 'Últimos 30 dias',
        currentMonth: 'Mês atual',
        lastMonth: 'Mês anterior',
        currentYear: 'Ano atual',
        lastYear: 'Ano anterior',
        everyPeriod: 'Todo período',
        customized: 'Personalizado',
        choose: 'Escolha o período',
      },
      editCard: {
        title: 'Editar card',
        description:
          'Edite seu card personalizado para o seu painel, digite o nome e escolha as métricas que atendem melhor a sua necessidade.',
        titlePanel: 'Título do painel',
        chooseMetric: 'Escolha a métrica',
        chooseTypeAnalysis: 'Escolha o tipo de análise',
        chooseReport: 'Escolha o relatório a ser exibido',
        choosePeriod: 'Escolha o período',
        chooseFilter: 'Escolha o filtro',
        chooseAction: 'Escolha a ação',
        chooseBranch: 'Escolha a filial',
        chooseIndicator: 'Escolha o indicador',
        showMore: 'Carregar mais',
        chooseValueIndicator: 'Escolha o valor do indicador',
        chooseTypeGraph: 'Escolha o tipo de gráfico a ser utilizado',
        graphics: 'Gráficos',
        save: 'Salvar',
        cancel: 'Cancelar',
      },
      chooseFilterTitle: 'Escolha o filtro',
      chooseFilter: {
        actionGroup: 'Grupo de ações',
        action: 'Ação',
        indicator: 'Indicador',
        filial: 'Filial',
      },
      panelHeader: {
        srcPanel: 'Buscar painel',
        edit: 'Editar',
        reload: 'Recarregar',
        custom: 'Customização',
        addGraphcs: 'Adicionar gráfico',
        loadMore: 'Carregar mais>>',
      },
      homePageCard: {
        metric: 'Métrica',
        actionGroup: 'Grupo de ação',
        branch: 'Filial',
        area: 'Area',
        data: 'Data',
        action: 'Ação',
        title: 'Preencha com um título',
        chooseGraphicsType: 'Escolha o tipo de gráfico a ser utilizado',
      },
      formTextArea: {
        chooseAnalysis: 'Selecione uma análise',
        choosePeriod: 'Escolha um periodo',
        chooseFilterDescription: 'Escolha o filtro',
        chooseMetric: 'Selecione a métrica',
      },
      filterOptions: {
        actionGroupName: 'Escolha um grupo',
        action: 'Selecione uma ação',
        indicator: 'Selecione um indicador',
        filial: 'Selecione uma Filial',
        chooseActionTitle: 'Escolha a ação',
        chooseFilialTitle: 'Escolha a filial',
        chooseInicatorTitle: 'Escolha o indicador',
        chooseIndicatorValue: 'Escolha o valor do indicador',
        chooseValue: 'Escolha um valor',
      },
      metrics: {
        selectMetric: 'Selecione a métrica',
        nps0to10: 'NPS - escala 0 a 10',
        nps1to5: 'NPS - escala 1 a 5',
        ces1to5: 'CES - escala 1 a 5',
        csat1To5: 'CSAT - escala 1 a 5(Top 2 box)',
        csat1To5Media: 'CSAT - escala 1 a 5(media)',
        fiveStars: '5-Stars',
        likeDislike: 'Like/Dislike 0 e 1',
      },
    },
    pageHome: {
      titlePage: 'Meus painéis - Beta',
      findPanel: 'Buscar painel',
      noHavePanel: 'Você ainda não possui nenhum painel customizado!',
      morePanel: '+ Adicionar painel',
      wouldDelete: 'Você tem certeza que deseja excluir este painel?',
      wouldDeleteCard: '',
      description:
        'Todas as alterações configuradas serão perdidas e você não poderá recuperá-las.',
      yes: 'Sim',
      no: 'Não',
      date: 'Data',
    },
    generalButtons: {
      edit: 'Editar',
      delete: 'Apagar',
      addGraphics: 'Adicionar',
      save: 'Salvar',
      reload: 'Recarregar',
      custom: 'Customização',
      addGraphcs: 'Adicionar gráfico',
      findPanel: 'Buscar Painel',
    },
  },

  actionTranslateUpdate: {
    multiLanguage: 'Multiplo Idioma',
    pauseAction: 'Pausar Ação',
    yes: 'Sim',
    no: 'Não',
    staticQuest:
      'Em uma escala de 1 a 5, quanto você indicatia a IndeCX para um amigo ou familiar?',
    requireAddQuest: 'Obrigatório por pergunta adicional',
    textBeforeEmoji: 'Ao habilitar esta opção, irá exibir nas configurações',
    textAfterEmoji:
      'de cada pergunta a possibilidade de deixar aquela pergunta adicional obrigatória.',
    options: {
      title: 'Opções.',
      clone: 'Clonar ação',
      groupCategory: 'Grupo de categoria',
      groupTagsTreatment: 'Grupo tags de tratativa',
      groupTags: 'Group tag',
      removeAction: 'Remover ação',
      webHookRegister: 'Registrar webhook',
      emailRegister: 'Registrar Email (remetente)',
      hideDefault: 'Ocultar por padrão',
    },
    logicRules: {
      modalTitle: 'Regras lógicas',
      description:
        'Crie regras para desabilitar perguntas de acordo com a resposta de seus clientes',
      conditionals: 'Se a resposta da pergunta abaixo   ',
      is: 'For',
      equal: 'Igual a',
      larger: 'Maior que',
      largerOrEqual: 'Maior ou igual a',
      smaller: 'Menor que',
      smallerOrEqual: 'Menor ou igual a',
      different: 'Diferente de',
      turnOff: 'Então desabilite as perguntas abaixo:',
      selectAnswer: 'Selecione uma resposta',
    },
    moreOptionsRules: {
      modalTitle: 'Mais opções',
      describe:
        'Habilite algumas das opções abaixo para adicionar customizações adicionais no seu questionário',
      addNewField: 'Adicionar um campo de comentário',
      notApply: 'Adicionar opção “Não aplica”',
      notApplyDescribe:
        ' Exibe a pergunta com base em uma condição da métrica principal',
      labelText:
        'Exibir a pergunta somente caso o perfil do respondente seja igual a:',
      seeAnswer:
        'Exibir a pergunta somente se o indicador selecionado abaixo for igual ou diferente do valor do parâmetro:',
      indicator: 'Indicador:',
      indicatorDescribe: ' As opções mudam de acordo com a empresa',
      critrion: 'Critério:',
      equal: 'Igual a',
      different: 'Diferente de',
      contains: 'Contém',
      params: 'Parâmetro:',
    },
    templateTranslateRef: {
      templateTitle: 'Template de botões',
      buttonScale: 'Escala de notas',
      button: 'Botão',
      automaticAnswer: 'Resposta automática',
      showIndecxLogo: 'Exibir logo IndeCX',
      noteRef: 'Referência de nota',
      customSubmitButton: 'Customizar botão enviar',
      default: 'Padrão',
      colors: '3 Cores',
    },
    quarentine: {
      dispatch: 'Disparo',
      period: 'Período em dias',
      validity: 'Validade:',
      options: {
        allData: 'Geral',
        thisAction: 'Para esta ação',
        actionGroup: 'Para o grupo de ações',
      },
      answer: 'Resposta',
    },
  },

  acumulated: 'Acumulado',

  configUpdateNow: {
    consumption: {
      email: 'Volume contratado e-mail',
      sms: 'Volume contratado SMS',
      semail: 'Saldo Atual e-mail',
      ssms: 'Saldo Atual SMS',
    },
    template: {
      subject: 'Retorno Equipe Experiência do Cliente',
      sender: 'Informa o nome do remetente',
      selectTemplate: 'Selecione um template',
      pressTemplateName: 'Digite o nome de um template',
      sucess: 'Sucesso!',
      descriptionSucess: 'Grupo de tag criado com sucesso',
      descriptionRemove: 'Grupo de tag removido com sucesso',
      descriptionUpdate: 'Grupo de tag atualizado com sucesso',
      alertAttetion: 'Atenção',
      alertDescription: 'Preencha todos os campos!',
      alertUpdate: 'Template atualizado',
      alertUpdateDescription: 'Seu template foi alterado com sucesso!',
    },
    tratativeRules: {
      modalTitle: 'Adicionar regra de tratativa',
      modalTitleEdit: 'Editar regra de tratativa',
      ruleTitle: 'Título da regra',
      ruleTime: 'Regras do período',
      classification: 'Classificar por',
      newlast: 'Mais recente',
      oldest: 'Mais antigo',
      ruleStack: 'Regras da fila do operador',
      orderWork: 'Ordem de trabalho ',
      schedule: 'Agendamento',
      detractor: 'Detradores',
      neutrals: 'Neutros',
      promoters: 'Promotores',
      chooseAnActions: 'Escolha as ações',
      actions: 'Ações',
      selectAction: 'Selecionar ações',
      newRoleButton: 'Nova regra de operação',
      isOn: 'Ativo',
      ruleName: 'Nome da regra',
      editeRule: 'Editar',
      channel: 'Canal',
      save: 'Salvar',
      saveChange: 'Salvar Alterações',
    },
  },

  userPermissionTranslateUpdate: {
    actionPermissionTitle: 'Menu Ações',
    actionMenu: {
      viewMenu: 'Visualizar Menu',
      details: 'Detalhes',
      editAction: 'Editar Ação',
      sendDispatcher: 'Enviar (disparo)',
      deleteAction: 'Excluir Ação',
      createAction: 'Criar Ação',
    },
    menuAnswers: {
      answerMenuTitle: '',
      answerMenu: {
        viewMenu: '',
        editComment: '',
        deleteResponse: '',
        incognitoMode: '',
        categorizationMode: '',
      },
    },
    manualMenuTitle: '',
    manualMenu: {
      viewMenu: '',
      registerAnswer: '',
      icognitoMode: '',
    },
    menuDispatcherTitle: '',
    menuDispatcher: {
      viewMenu: '',
      viewRessend: '',
      viewWhatsApp: '',
      resendExecute: '',
      remindersView: '',
      cancelReminders: '',
      scheduleView: '',
      scheduleCancel: '',
      incognitoMode: '',
    },
    treatmentMenuTitle: '',
    treatmentMenu: {
      viewMenu: '',
      details: '',
      answerCategory: '',
      changeStatus: '',
      chancheClosedStatus: '',
      massTreatment: '',
      replyByEmail: '',
      categorizeNegotiations: '',
      enableComment: '',
      enableResponsible: '',
      enableAttachment: '',
    },
    reportMenuTitle: '',
    reportMenu: {
      viewMenu: '',
      powerBi: '',
      AIAnalysis: '',
    },
    menuTrashTitle: '',
    menuTrash: {
      viewMenu: '',
      restoreAnswer: '',
      restoreActions: '',
      incognitoMode: '',
    },
    menuDashboardTitle: '',
    menuDashboard: {
      viewMenu: '',
    },

    menuClientTitle: '',
    menuClient: {
      viewMenu: '',
      incognitoMode: '',
      editData: '',
    },
    menuActionGroupTitle: '',
    menuActionGroup: {
      viewMenu: '',
      actionAssociation: '',
    },
    ourFileTitle: '',
    ourFileTitle: {
      downloads: '',
      uploads: '',
    },
    panelsMenuTitle: '',
    panelsMenu: {
      viewMenu: '',
      sharePanel: '',
      createPanel: '',
      editPanel: '',
      deletePanel: '',
    },
    myConfigurationsTitle: '',
    myConfigurations: {
      viewMenu: '',
    },
  },

  acessProfileTranslateUpdate: {
    modaltitle: 'Opções de relatórios',
    describe:
      'Habilite para esse perfil os relatórios específicos da sua conta',
    especificReport: {
      searchMonitoring: 'Monitoramento de pesquisa',
      conversionReport: 'Relatório de Conversão / Detalhamento importação',
      categories: 'Categoria x Tag Tratativa',
      htsReport: 'Relatório HTS',
    },
    especificReportTitle: 'Relatórios específicos',
    apply: 'Habilitar',
  },

  tagsTreatmenTranslateUpdate: {
    title: 'Tags de tratativas',
    addTag: 'Incluir Tags',
    removeTagTitle: 'Remover tag',
    describe: 'Tem certeza que deseja remover essa tag?',
  },

  actionUploadModal: {
    title: 'Processando',
    description:
      'Seu arquivo está sendo processado, por favor aguarde! Isso pode demorar alguns segundos.',
  },
};

export default messages;



// WEBPACK FOOTER //
// ./src/lang/br.js